(function () {
  var root = document.getElementById("cobbler-chatbot-root");

  if (!root) {
    return;
  }

  var config = {
    title: root.dataset.title || "Le cordonnier Trolet",
    webhookUrl: root.dataset.webhookUrl || "",
    uploadMode: root.dataset.uploadMode || "upload-endpoint",
    uploadEndpoint: root.dataset.uploadEndpoint || "",
    uploadPreset: root.dataset.uploadPreset || "",
    minImagesPerShoe: Number(root.dataset.minImages || 1),
    maxImagesPerShoe: Number(root.dataset.maxImages || 5),
    maxShoes: Number(root.dataset.maxShoes || 3),
    maxImagesTotal: Number(root.dataset.maxImagesTotal || 15),
    maxUploadTotalMb: Number(root.dataset.maxUploadTotalMb || 64),
    maxUploadFileMb: Number(root.dataset.maxUploadFileMb || 8),
    uploadTimeoutMs: Number(root.dataset.uploadTimeoutMs || 30000),
    storeDomain: root.dataset.storeDomain || "",
    pageUrl: root.dataset.pageUrl || window.location.href,
    iconUrl: root.dataset.iconUrl || "",
    operatorIconUrl: root.dataset.operatorIconUrl || "",
    closeupImageUrl: root.dataset.closeupImageUrl || "",
    soleImageUrl: root.dataset.soleImageUrl || "",
    angleImageUrl: root.dataset.angleImageUrl || "",
    issueIconUrls: {
      "Talon use": root.dataset.issueIconHeelUrl || "",
      "Semelle decollee": root.dataset.issueIconSoleUrl || "",
      "Cuir egratigne": root.dataset.issueIconLeatherUrl || "",
      "Couture ouverte": root.dataset.issueIconSeamUrl || "",
      "Nettoyage ou entretien": root.dataset.issueIconCleaningUrl || "",
      "Autre probleme": root.dataset.issueIconOtherUrl || ""
    },
    shoeTypeIconUrls: {
      "Chaussures habillees": root.dataset.shoeTypeIconDressUrl || "",
      "Bottes": root.dataset.shoeTypeIconBootsUrl || "",
      "Sneakers": root.dataset.shoeTypeIconSneakersUrl || "",
      "Sandales": root.dataset.shoeTypeIconSandalsUrl || "",
      "Autre": root.dataset.shoeTypeIconOtherUrl || ""
    },
    cameraIconUrl: root.dataset.cameraIconUrl || "",
    importIconUrl: root.dataset.importIconUrl || "",
    launcherShapeUrl: root.dataset.launcherShapeUrl || "",
    turnstileSitekey: root.dataset.turnstileSitekey || "",
    pairImages: [root.dataset.pairImageOne || "", root.dataset.pairImageTwo || "", root.dataset.pairImageThree || ""]
  };

  if (!Number.isFinite(config.maxShoes) || config.maxShoes < 1) {
    config.maxShoes = 1;
  }
  if (!Number.isFinite(config.minImagesPerShoe) || config.minImagesPerShoe < 1) {
    config.minImagesPerShoe = 1;
  }
  if (!Number.isFinite(config.maxImagesPerShoe) || config.maxImagesPerShoe < config.minImagesPerShoe) {
    config.maxImagesPerShoe = Math.max(config.minImagesPerShoe, 5);
  }
  if (!Number.isFinite(config.maxImagesTotal) || config.maxImagesTotal < config.minImagesPerShoe) {
    config.maxImagesTotal = config.maxShoes * config.maxImagesPerShoe;
  }
  if (!Number.isFinite(config.maxUploadTotalMb) || config.maxUploadTotalMb < 1) {
    config.maxUploadTotalMb = 64;
  }
  if (!Number.isFinite(config.uploadTimeoutMs) || config.uploadTimeoutMs < 1000) {
    config.uploadTimeoutMs = 30000;
  }
  config.maxShoes = Math.min(config.maxShoes, 3);
  config.maxImagesPerShoe = Math.min(config.maxImagesPerShoe, 5);
  config.maxImagesTotal = Math.min(config.maxImagesTotal, 15);
  config.maxUploadTotalBytes = config.maxUploadTotalMb * 1024 * 1024;
  config.maxUploadFileBytes = config.maxUploadFileMb * 1024 * 1024;

  if (config.launcherShapeUrl) {
    var launcherShapeUrl = new URL(config.launcherShapeUrl, window.location.href).href;
    root.style.setProperty("--cb-launcher-shape-url", 'url("' + launcherShapeUrl.replace(/"/g, '\\"') + '")');
  } else {
    root.style.removeProperty("--cb-launcher-shape-url");
  }

  var issueChoices = [
    "Talon use",
    "Semelle decollee",
    "Cuir egratigne",
    "Couture ouverte",
    "Nettoyage ou entretien",
    "Autre probleme"
  ];

  var issueChoiceLabels = {
    "Talon use": "Talon usé",
    "Semelle decollee": "Semelle décollée",
    "Cuir egratigne": "Cuir égratigné",
    "Couture ouverte": "Couture ouverte",
    "Nettoyage ou entretien": "Nettoyage ou entretien",
    "Autre probleme": "Autre problème"
  };

  var shoeTypeChoices = [
    "Chaussures habillees",
    "Bottes",
    "Sneakers",
    "Sandales",
    "Autre"
  ];

  var shoeTypeLabels = {
    "Chaussures habillees": "Chaussures habillées",
    "Bottes": "Bottes",
    "Sneakers": "Sneakers",
    "Sandales": "Sandales",
    "Autre": "Autre"
  };

  var steps = buildSteps();
  var answerLabels = buildAnswerLabels();

  var state = {
    isOpen: false,
    sessionId: getOrCreateSessionId(),
    currentStepIndex: 0,
    requestNumber: null,
    shoeCount: 1,
    phoneTooLong: false,
    submitting: false,
    completed: false,
    returnToSummary: false,
    promptDelayActive: false,
    actionDelayActive: false,
    introVisibleCount: 0,
    introSequenceStarted: false,
    operatorTypingCompleted: {},
    submitPhase: "",
    activeImageSlot: null,
    galleryStepId: null,
    uploadedImageCount: 0,
    uploadCache: {},
    uploadFailures: [],
    status: {
      message: "",
      tone: ""
    },
    answers: buildInitialAnswers()
  };

  var introTimers = [];
  var promptDelayTimer = null;
  var operatorActionDelayTimer = null;
  var operatorTypingTimers = [];
  var scrollIntent = "";
  var turnstileScriptPromise = null;
  var activeTurnstileWidgetId = null;
  var choiceIconPreloadStarted = false;
  var choiceIconPreloads = [];

  var autoOpenFromUrl = shouldOpenFromUrl();
  if (autoOpenFromUrl) {
    state.isOpen = true;
    preloadChoiceIcons();
  }
  renderApp();
  if (autoOpenFromUrl) {
    startIntroSequence();
  }
  window.addEventListener("click", handleChatbotOpenLinkClick, true);

  function preloadChoiceIcons() {
    if (choiceIconPreloadStarted) {
      return;
    }

    choiceIconPreloadStarted = true;
    var seen = {};
    var urls = Object.keys(config.issueIconUrls).map(function (key) {
      return config.issueIconUrls[key];
    }).concat(Object.keys(config.shoeTypeIconUrls).map(function (key) {
      return config.shoeTypeIconUrls[key];
    }));

    urls.forEach(function (url) {
      if (!url || seen[url]) {
        return;
      }

      seen[url] = true;
      var image = new Image();
      image.decoding = "async";
      image.src = url;
      choiceIconPreloads.push(image);
    });
  }

  function shouldOpenFromUrl() {
    try {
      return new URLSearchParams(window.location.search).get("chatbot") === "open";
    } catch (_error) {
      return false;
    }
  }

  function handleChatbotOpenLinkClick(event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    var target = event.target;
    var link = target && typeof target.closest === "function" ? target.closest("a[href]") : null;
    if (!link || !isChatbotOpenLink(link)) {
      return;
    }

    event.preventDefault();
    openChatbot();
  }

  function isChatbotOpenLink(link) {
    try {
      return new URL(link.getAttribute("href"), window.location.href).searchParams.get("chatbot") === "open";
    } catch (_error) {
      return false;
    }
  }

  function openChatbot() {
    if (state.submitting || state.isOpen) {
      return;
    }

    state.isOpen = true;
    preloadChoiceIcons();
    requestScrollToBottom();
    startIntroSequence();
    renderApp();
  }

  function closeChatbot() {
    if (state.submitting || !state.isOpen) {
      return;
    }

    state.isOpen = false;
    clearIntroTimers();
    clearStepPromptDelay();
    clearOperatorActionDelay();
    renderApp();
  }

  function buildSteps() {
    var out = [{
      id: "shoeCount",
      type: "choice-with-skip",
      label: "Nombre de paires",
      prompt: "Commençons par tes chaussures.",
      choices: [
        { value: "1", label: "1 paire", hint: "Rapide — environ 1 min 30 s" },
        { value: "2", label: "2 paires", hint: "Deux diagnostics groupés" },
        { value: "3", label: "3 paires", hint: "Trois diagnostics groupés" }
      ]
    }];

    for (var shoeIndex = 1; shoeIndex <= config.maxShoes; shoeIndex += 1) {
      out.push({
        id: "images_" + String(shoeIndex),
        type: "images",
        label: "Photos chaussure " + String(shoeIndex),
        prompt: "Concernant la " + (shoeIndex === 1 ? "première" : shoeIndex === 2 ? "deuxième" : "troisième") + " paire.",
        shoeIndex: shoeIndex
      });
      out.push({
        id: "issue_" + String(shoeIndex),
        type: "choice-with-other",
        label: "Problème chaussure " + String(shoeIndex),
        prompt: "Voici les services possibles.",
        choices: issueChoices,
        otherValue: "Autre probleme",
        otherPlaceholder: "Décris le problème",
        shoeIndex: shoeIndex
      });
      out.push({
        id: "shoeType_" + String(shoeIndex),
        type: "choice-with-other",
        label: "Type chaussure " + String(shoeIndex),
        prompt: "Encore une petite précision sur cette paire.",
        choices: shoeTypeChoices,
        otherValue: "Autre",
        otherPlaceholder: "Précise le type",
        shoeIndex: shoeIndex
      });

    }

    out.push({
      id: "customerName",
      type: "text",
      label: "Prénom et nom",
      prompt: "À quel nom doit-on ouvrir le dossier ?",
      placeholder: "Prénom et nom"
    });

    out.push({
      id: "customerPhone",
      type: "phone",
      label: "Téléphone",
      prompt: "Quel est ton numéro de téléphone ?",
      placeholder: "+1 (514) 555-1212"
    });

    out.push({
      id: "customerEmail",
      type: "email",
      label: "Email",
      prompt: "À quelle adresse e-mail doit-on t’écrire ?",
      placeholder: "nom@exemple.com"
    });

    out.push({
      id: "additionalNotes",
      type: "textarea-optional",
      label: "Détails supplémentaires (facultatif)",
      prompt: "Souhaites-tu ajouter des détails complémentaires à ta demande ? Cette étape est facultative.",
      placeholder: "Ce que le cordonnier devrait savoir (facultatif)"
    });

    out.push({
      id: "summary",
      type: "summary",
      label: "Récapitulatif",
      prompt: "Voici le récapitulatif de ta demande."
    });

    return out;
  }

  function buildAnswerLabels() {
    var labels = {
      shoeCount: "Nombre de paires",
      customerEmail: "Email",
      customerName: "Nom et prénom",
      customerPhone: "Téléphone",
      additionalNotes: "Détails supplémentaires"
    };

    for (var shoeIndex = 1; shoeIndex <= config.maxShoes; shoeIndex += 1) {
      labels["images_" + String(shoeIndex)] = "Photos chaussure " + String(shoeIndex);
      labels["issue_" + String(shoeIndex)] = "Problème chaussure " + String(shoeIndex);
      labels["shoeType_" + String(shoeIndex)] = "Type chaussure " + String(shoeIndex);
    }

    return labels;
  }

  function buildInitialAnswers() {
    var answers = {
      customerEmail: "",
      customerName: "",
      customerPhone: "",
      additionalNotes: ""
    };

    for (var shoeIndex = 1; shoeIndex <= config.maxShoes; shoeIndex += 1) {
      answers["images_" + String(shoeIndex)] = [];
      answers["issue_" + String(shoeIndex)] = [];
      answers["issueDetail_" + String(shoeIndex)] = "";
      answers["shoeType_" + String(shoeIndex)] = [];
      answers["shoeTypeDetail_" + String(shoeIndex)] = "";
    }

    return answers;
  }

  function renderApp() {
    clearOperatorTypingTimers();
    var previousBody = root.querySelector(".cobbler-chatbot__panel-body");
    var previousScrollTop = previousBody ? previousBody.scrollTop : 0;
    var shouldFollowBottom = previousBody ? isNearBottom(previousBody) : false;

    root.innerHTML = render();
    bind();
    startOperatorTypingEffects();

    restoreScroll(previousScrollTop, shouldFollowBottom);
  }

  function render() {
    var launcherShapeClass = config.launcherShapeUrl ? " has-custom-shape" : "";

    return [
      '<div class="cobbler-chatbot__launcher-shell">',
      '  <div class="cobbler-chatbot__launcher-stack">',
      '    <button type="button" class="cobbler-chatbot__launcher' + launcherShapeClass + '" data-launcher' + (state.submitting ? ' disabled' : '') + ' aria-expanded="' + String(state.isOpen) + '" aria-controls="cobbler-chatbot-panel">',
      '      <span class="cobbler-chatbot__launcher-rings' + launcherShapeClass + '"></span>',
      "    </button>",
      '    <span class="cobbler-chatbot__launcher-logo" aria-hidden="true">',
      renderBrandIcon("launcher"),
      "    </span>",
      '    <span class="cobbler-chatbot__launcher-label"><span>Diagnostic</span><span>Reparation Express</span></span>',
      "  </div>",
      "</div>",
      '<aside id="cobbler-chatbot-panel" class="cobbler-chatbot__panel' + (state.isOpen ? " is-open" : "") + '" aria-hidden="' + String(!state.isOpen) + '">',
      renderHeader(),
      '  <div class="cobbler-chatbot__panel-body">',
      renderConversation(),
      renderComposer(),
      renderStatus(),
      "  </div>",
      "</aside>"
    ].join("");
  }

  function renderHeader() {
    return [
      '<div class="cobbler-chatbot__panel-header">',
      '  <div class="cobbler-chatbot__identity">',
      '    <div class="cobbler-chatbot__mark">' + renderBrandIcon("mark") + "</div>",
      '    <div class="cobbler-chatbot__identity-copy">',
      '      <div class="cobbler-chatbot__eyebrow">Atelier Trolet</div>',
      '      <h2 class="cobbler-chatbot__title">' + escapeHtml(config.title) + "</h2>",
      renderHeaderProgress(),
      "    </div>",
      "  </div>",
      '  <div class="cobbler-chatbot__panel-actions">',
      '    <button type="button" class="cobbler-chatbot__icon-button" data-reset' + (state.submitting ? " disabled" : "") + ' aria-label="Recommencer">',
      '      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5a7 7 0 1 1-6.32 4H3l3.5-3.5L10 9H7.77A5 5 0 1 0 12 7a1 1 0 0 1 0-2z" fill="currentColor"/></svg>',
      "    </button>",
      '    <button type="button" class="cobbler-chatbot__icon-button" data-close' + (state.submitting ? " disabled" : "") + ' aria-label="Fermer">',
      '      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.7 5.3 12 10.6l5.3-5.3 1.4 1.4L13.4 12l5.3 5.3-1.4 1.4L12 13.4l-5.3 5.3-1.4-1.4 5.3-5.3-5.3-5.3z" fill="currentColor"/></svg>',
      "    </button>",
      "  </div>",
      "</div>"
    ].join("");
  }

  function renderConversation() {
    var history = [];
    var showAnimatedIntro = state.isOpen && state.currentStepIndex === 0 && !state.completed;
    var introVisibleCount = showAnimatedIntro ? state.introVisibleCount : 2;

    if (state.currentStepIndex === 0 && introVisibleCount >= 1) {
      history.push({
        key: "intro",
        role: "bot",
        text: "Bonjour, je vais t’aider à obtenir un diagnostic fiable et rapide pour tes chaussures. Cela prend environ 2 minutes."
      });
    }

    var currentStep = getCurrentStep();
    var showPromptDelay = state.promptDelayActive && currentStep && currentStep.id !== "summary";
    if (!showPromptDelay && (introVisibleCount >= 2 || state.completed) && currentStep && currentStep.id !== "shoeCount" && currentStep.id !== "summary") {
      history.push({ key: getStepPromptKey(currentStep), role: "bot", text: getStepPromptText(currentStep) });
    }

    if (state.completed) {
      history.push({
        key: "completed",
        role: "bot",
        text: "Merci.\n\nTa demande est en cours d’analyse par l’atelier.\n\nTu vas recevoir à l’instant un récapitulatif par courriel et, dans les prochaines 24 h, la réponse de ton cordonnier."
      });
    }

    return [
      '<div class="cobbler-chatbot__conversation">',
      history.map(function (item) {
        if (item.role === "bot") {
          var messageKey = item.key || item.text;
          if (state.operatorTypingCompleted[messageKey]) {
            return '<div class="cobbler-chatbot__message cobbler-chatbot__message--bot"><span class="cobbler-chatbot__message-copy" style="white-space:pre-line" aria-live="polite">' + escapeHtml(item.text) + '</span></div>';
          }
          return '<div class="cobbler-chatbot__message cobbler-chatbot__message--bot"><span class="cobbler-chatbot__message-copy" style="white-space:pre-line" data-operator-key="' + escapeAttribute(messageKey) + '" data-operator-text="' + escapeAttribute(item.text) + '" aria-live="polite"></span></div>';
        }
        return '<div class="cobbler-chatbot__message cobbler-chatbot__message--' + item.role + '">' + escapeHtml(item.text) + "</div>";
      }).join(""),
      ((showAnimatedIntro && introVisibleCount < 2) || showPromptDelay) ? renderTypingBubble() : "",
      "</div>"
    ].join("");
  }

  function renderOperatorIcon() {
    if (config.operatorIconUrl) {
      return '<img src="' + escapeAttribute(config.operatorIconUrl) + '" alt="" aria-hidden="true" />';
    }

    return '<svg viewBox="0 0 32 32" focusable="false"><circle cx="16" cy="11" r="4"/><path d="M8 27c1-5 4-8 8-8s7 3 8 8"/><path d="M6 14a10 10 0 0 1 20 0v4M6 15h3v6H6zm17 0h3v6h-3z"/></svg>';
  }

  function renderHeaderProgress() {
    if (state.completed) {
      return "";
    }

    var progress = getProgressDescriptor(getCurrentStep());
    return [
      '<div class="cobbler-chatbot__header-progress" aria-label="Étape ' + String(progress.position) + ' sur ' + String(progress.total) + '">',
      '  <span class="cobbler-chatbot__header-progress-caption"><strong>' + escapeHtml(progress.label) + '</strong><span>' + String(progress.position) + ' sur ' + String(progress.total) + '</span></span>',
      '  <span class="cobbler-chatbot__header-progress-bar"><span class="cobbler-chatbot__header-progress-fill" style="width:' + String(Math.round((progress.position / progress.total) * 100)) + '%"></span></span>',
      "</div>"
    ].join("");
  }

  function getProgressDescriptor(step) {
    var current = step || {};
    if (current.id === "shoeCount") {
      return { label: "Tes chaussures", position: 1, total: 5 };
    }
    if (current.type === "images") {
      return { label: "Photos • Paire " + String(current.shoeIndex) + " sur " + String(state.shoeCount), position: 2, total: 5 };
    }
    if (current.type === "choice-with-other" && isIssueStep(current.id)) {
      return { label: "Le problème", position: 3, total: 5 };
    }
    if (current.type === "choice-with-other" && isShoeTypeStep(current.id)) {
      return { label: "Le type de chaussure", position: 4, total: 5 };
    }
    if (current.type === "summary") {
      return { label: "Vérification", position: 5, total: 5 };
    }
    if (current.id === "additionalNotes") {
      return { label: "Détails facultatifs", position: 5, total: 5 };
    }
    return { label: "Coordonnées", position: 5, total: 5 };
  }

  function renderTypingBubble() {
    return [
      '<div class="cobbler-chatbot__message cobbler-chatbot__message--bot cobbler-chatbot__message--typing" aria-hidden="true">',
      "  <span></span><span></span><span></span>",
      "</div>"
    ].join("");
  }

  function renderBrandIcon(variant) {
    if (config.iconUrl) {
      var imageClass = variant === "mark"
        ? "cobbler-chatbot__brand-image cobbler-chatbot__brand-image--mark"
        : "cobbler-chatbot__brand-image cobbler-chatbot__brand-image--launcher";
      return '<img class="' + imageClass + '" src="' + escapeAttribute(config.iconUrl) + '" alt="" aria-hidden="true" />';
    }

    return '<svg class="cobbler-chatbot__brand-svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 21h14v-2H5zm7-18L5.33 9h3.84v4h5.66V9h3.84z" fill="currentColor"/></svg>';
  }

  function renderComposer() {
    if (state.completed) {
      return '<div class="cobbler-chatbot__actions cobbler-chatbot__actions--single"><button type="button" class="cobbler-chatbot__button cobbler-chatbot__button--primary" data-done>Terminé</button></div>';
    }

    if (state.isOpen && state.currentStepIndex === 0 && state.introVisibleCount < 2) {
      return "";
    }

    if (state.promptDelayActive || state.actionDelayActive) {
      return "";
    }

    var step = getCurrentStep();

    if (!step) {
      return "";
    }

    if (step.type === "summary") {
      return renderSummaryComposer();
    }

    return [
      '<div class="cobbler-chatbot__composer">',
      renderStepCard(step),
      renderActions(step),
      "</div>"
    ].join("");
  }

  function renderStepCard(step) {
    if (step.id === "shoeCount") {
      return [
        '<div class="cobbler-chatbot__pair-count-card">',
        '  <div class="cobbler-chatbot__step-kicker">Tes chaussures</div>',
        '  <h3 class="cobbler-chatbot__step-title">Combien de paires souhaites-tu inclure dans cette demande&nbsp;?</h3>',
        '  <div class="cobbler-chatbot__pair-count-options">',
        renderPairCountCards(step),
        "  </div>",
        '  <p class="cobbler-chatbot__pair-count-note">Plus de 3 paires&nbsp;? Effectue une nouvelle demande.</p>',
        "</div>"
      ].join("");
    }

    if (step.type === "images") {
      var fileKey = step.id;
      var files = state.answers[fileKey] || [];
      var remainingGlobalSlots = Math.max(0, config.maxImagesTotal - (getTotalSelectedImages() - countSelectedFiles(files)));
      var maxForCurrentShoe = Math.min(config.maxImagesPerShoe, remainingGlobalSlots);
      return [
        '<div class="cobbler-chatbot__photo-step">',
        '  <div class="cobbler-chatbot__photo-heading">',
        '    <div class="cobbler-chatbot__step-kicker">Photos</div>',
        '    <h3 class="cobbler-chatbot__step-title">Ajoute entre ' + config.minImagesPerShoe + " et " + config.maxImagesPerShoe + " photos nettes.</h3>",
        "  </div>",
        renderPhotoSlots(fileKey, files),
        '  <input class="cobbler-chatbot__file-input" id="cobbler-chatbot-images-import" data-image-input="import" type="file" name="images" accept="image/*" multiple />',
        '  <input class="cobbler-chatbot__file-input" id="cobbler-chatbot-images-camera" data-image-input="camera" type="file" name="camera" accept="image/*" capture="environment" />',
        '  <div class="cobbler-chatbot__photo-actions">',
        "  </div>",
        '  <div class="cobbler-chatbot__photo-source-picker" data-image-source-picker hidden>',
        '    <button type="button" class="cobbler-chatbot__photo-source-backdrop" data-image-source-close aria-label="Fermer"></button>',
        '    <div class="cobbler-chatbot__photo-source-dialog" role="dialog" aria-modal="true" aria-labelledby="cobbler-chatbot-photo-source-title" tabindex="-1">',
        '      <div class="cobbler-chatbot__photo-source-heading">',
        '        <strong id="cobbler-chatbot-photo-source-title">Ajouter une photo</strong>',
        '        <button type="button" class="cobbler-chatbot__photo-source-close" data-image-source-close aria-label="Fermer">&times;</button>',
        "      </div>",
        '      <p>Choisis comment tu veux ajouter cette photo.</p>',
        '      <div class="cobbler-chatbot__photo-source-options">',
        '        <button type="button" class="cobbler-chatbot__button cobbler-chatbot__button--secondary" data-image-source="camera">Prendre une photo</button>',
        '        <button type="button" class="cobbler-chatbot__button cobbler-chatbot__button--secondary" data-image-source="import">Choisir dans la galerie</button>',
        "      </div>",
        "    </div>",
        "  </div>",
        "</div>"
      ].join("");
    }

    if (step.type === "choice-with-other") {
      if (isIssueStep(step.id)) {
        return renderIssueCard(step);
      }
      if (isShoeTypeStep(step.id)) {
        return renderShoeTypeCard(step);
      }
      var selectedPrimaryValue = getPrimaryAnswer(step.id);
      var hasOtherSelected = Array.isArray(selectedPrimaryValue)
        ? selectedPrimaryValue.indexOf(step.otherValue) !== -1
        : selectedPrimaryValue === step.otherValue;
      return [
        '<div class="cobbler-chatbot__input-card cobbler-chatbot__input-card--choice">',
        renderChoiceButtons(step),
        hasOtherSelected ? '<label><span class="cobbler-chatbot__label">Précision</span><input type="text" data-field="' + step.id + '" value="' + escapeAttribute(getOtherAnswer(step.id)) + '" placeholder="' + escapeAttribute(step.otherPlaceholder) + '" /></label>' : "",
        "</div>"
      ].join("");
    }

    if (step.type === "choice-cards") {
      return '<div class="cobbler-chatbot__input-card cobbler-chatbot__input-card--choice-cards">' + renderChoiceCards(step) + "</div>";
    }

    if (step.type === "choice-with-skip" || step.type === "add-shoe") {
      return '<div class="cobbler-chatbot__input-card cobbler-chatbot__input-card--choice">' + renderChoiceButtons(step) + "</div>";
    }

    if (step.type === "text" || step.type === "email" || step.type === "phone") {
      var inputType = step.type === "email" ? "email" : step.type === "phone" ? "tel" : "text";
      return '<div class="cobbler-chatbot__input-card cobbler-chatbot__input-card--text"><label><span class="cobbler-chatbot__label">' + escapeHtml(step.label) + '</span><input type="' + inputType + '" data-field="' + step.id + '" value="' + escapeAttribute(state.answers[step.id] || "") + '" placeholder="' + escapeAttribute(step.placeholder || "") + '" /></label></div>';
    }

    if (step.type === "textarea-optional") {
      return '<div class="cobbler-chatbot__input-card cobbler-chatbot__input-card--text"><label><span class="cobbler-chatbot__label">' + escapeHtml(step.label) + '</span><textarea data-field="' + step.id + '" placeholder="' + escapeAttribute(step.placeholder || "") + '">' + escapeHtml(state.answers[step.id] || "") + "</textarea></label></div>";
    }

    return "";
  }

  function renderPairCountCards(step) {
    return step.choices.map(function (choice, index) {
      var isActive = String(state.shoeCount) === String(choice.value);
      var pairImageUrl = config.pairImages[index] || "";
      var illustration = pairImageUrl
        ? '<img class="cobbler-chatbot__pair-count-image" data-pair-image src="' + escapeAttribute(pairImageUrl) + '" alt="" loading="lazy"><span class="cobbler-chatbot__pair-count-fallback" data-pair-image-fallback hidden>' + renderPairIllustration(index + 1) + '</span>'
        : renderPairIllustration(index + 1);
      return [
        '<button type="button" class="cobbler-chatbot__pair-count-option' + (isActive ? " is-active" : "") + '" data-choice-step="shoeCount" data-choice-value="' + escapeAttribute(choice.value) + '">',
        '  <span class="cobbler-chatbot__pair-count-illustration" aria-hidden="true">' + illustration + "</span>",
        '  <span class="cobbler-chatbot__pair-count-copy"><strong>' + escapeHtml(choice.label) + '</strong><small>' + escapeHtml(choice.hint) + "</small></span>",
        '  <span class="cobbler-chatbot__pair-count-check" aria-hidden="true">' + (isActive ? "✓" : "") + "</span>",
        "</button>"
      ].join("");
    }).join("");
  }

  function renderPairContextCard(step, files) {
    var firstFile = getFirstSelectedFile(files);
    var preview = firstFile && firstFile.previewUrl;
    var shoeVisual = preview
      ? '<img src="' + escapeAttribute(preview) + '" alt="" />'
      : '<span class="cobbler-chatbot__pair-context-icon cobbler-chatbot__pair-context-icon--fallback" aria-hidden="true">' + renderShoeTypeIcon("Chaussures habillees") + '</span>';
    var count = countSelectedFiles(files);
    var isGalleryOpen = state.galleryStepId === step.id;
    return '<div class="cobbler-chatbot__pair-context" data-pair-gallery-step="' + escapeAttribute(step.id) + '" role="button" tabindex="0" aria-expanded="' + String(isGalleryOpen) + '"><span class="cobbler-chatbot__pair-context-visual">' + shoeVisual + '</span><span class="cobbler-chatbot__pair-context-copy"><strong>Paire ' + String(step.shoeIndex) + '</strong><small>' + String(count) + ' photo' + (count === 1 ? '' : 's') + '</small></span><span class="cobbler-chatbot__pair-context-chevron" aria-hidden="true">›</span></div>' + (isGalleryOpen ? renderPairPhotoGallery(step, files) : '');
  }

  function renderPairPhotoGallery(step, files) {
    var selectedFiles = (files || []).filter(function (file) {
      return file && file.name;
    });

    if (!selectedFiles.length) {
      return '<div class="cobbler-chatbot__pair-gallery"><div class="cobbler-chatbot__pair-gallery-heading"><strong>Photos de la paire ' + String(step.shoeIndex) + '</strong><button type="button" class="cobbler-chatbot__pair-gallery-close" data-pair-gallery-close aria-label="Fermer la galerie">×</button></div><p class="cobbler-chatbot__pair-gallery-empty">Aucune photo ajoutée pour le moment.</p></div>';
    }

    return '<div class="cobbler-chatbot__pair-gallery"><div class="cobbler-chatbot__pair-gallery-heading"><div><strong>Photos de la paire ' + String(step.shoeIndex) + '</strong><small>' + String(selectedFiles.length) + ' photo' + (selectedFiles.length === 1 ? '' : 's') + '</small></div><button type="button" class="cobbler-chatbot__pair-gallery-close" data-pair-gallery-close aria-label="Fermer la galerie">×</button></div><div class="cobbler-chatbot__pair-gallery-grid">' + selectedFiles.map(function (file, index) {
      return '<figure class="cobbler-chatbot__pair-gallery-item"><div class="cobbler-chatbot__pair-gallery-image">' + (file.previewUrl ? '<img src="' + escapeAttribute(file.previewUrl) + '" alt="Photo ' + String(index + 1) + ' de la paire ' + String(step.shoeIndex) + '" />' : '<span aria-hidden="true">Photo</span>') + '</div><figcaption>Photo ' + String(index + 1) + '</figcaption></figure>';
    }).join('') + '</div></div>';
  }

  function renderShoeContextIcon() {
    return '<svg viewBox="0 0 32 28" focusable="false"><path d="M3 19c4-2 7-6 9-12l2-3c1-2 3-2 5-1l5 5c2 2 4 3 6 4l1 5H4c-2 0-2-1-1-2Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"/><path d="M4 22h25" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.6"/></svg>';
  }

  function renderIssueCard(step) {
    var selected = state.answers[step.id] || [];
    var files = state.answers["images_" + String(step.shoeIndex)] || [];
    var hasOtherSelected = selected.indexOf(step.otherValue) !== -1;
    return [
      '<div class="cobbler-chatbot__input-card cobbler-chatbot__input-card--issue">',
      renderPairContextCard(step, files),
      '  <div class="cobbler-chatbot__issue-heading"><h3>De quel(s) service(s) cette paire a-t-elle besoin&nbsp;?</h3><p>Sélectionne tout ce qui s’applique.</p></div>',
      renderIssueChoiceButtons(step),
      hasOtherSelected ? '<label class="cobbler-chatbot__issue-detail"><span class="cobbler-chatbot__label">Précise le problème</span><input type="text" data-field="' + escapeAttribute(step.id) + '" value="' + escapeAttribute(getOtherAnswer(step.id)) + '" placeholder="Décris le problème" /></label>' : "",
      "</div>"
    ].join("");
  }

  function renderShoeTypeCard(step) {
    var selected = state.answers[step.id] || [];
    var files = state.answers["images_" + String(step.shoeIndex)] || [];
    var hasOtherSelected = selected.indexOf(step.otherValue) !== -1;
    return [
      '<div class="cobbler-chatbot__input-card cobbler-chatbot__input-card--issue">',
      renderPairContextCard(step, files),
      '  <div class="cobbler-chatbot__issue-heading"><h3>Quel est le type de chaussures&nbsp;?</h3><p>Sélectionne ce qui correspond le mieux.</p></div>',
      renderShoeTypeChoiceButtons(step),
      hasOtherSelected ? '<label class="cobbler-chatbot__issue-detail"><span class="cobbler-chatbot__label">Précise le type de chaussures</span><input type="text" data-field="' + escapeAttribute(step.id) + '" value="' + escapeAttribute(getOtherAnswer(step.id)) + '" placeholder="Décris le type de chaussures" /></label>' : "",
      "</div>"
    ].join("");
  }

  function renderIssueChoiceButtons(step) {
    var selected = state.answers[step.id] || [];
    return '<div class="cobbler-chatbot__issue-list">' + step.choices.map(function (choice) {
      var isActive = selected.indexOf(choice) !== -1;
      return '<button type="button" class="cobbler-chatbot__issue-choice' + (isActive ? " is-active" : "") + '" data-choice-step="' + escapeAttribute(step.id) + '" data-choice-value="' + escapeAttribute(choice) + '"><span class="cobbler-chatbot__issue-choice-icon" aria-hidden="true">' + renderIssueIcon(choice) + '</span><span class="cobbler-chatbot__issue-choice-label">' + escapeHtml(issueChoiceLabels[choice] || choice) + '</span><span class="cobbler-chatbot__issue-choice-check" aria-hidden="true">' + (isActive ? "✓" : "") + '</span></button>';
    }).join("") + "</div>";
  }

  function renderShoeTypeChoiceButtons(step) {
    var selected = state.answers[step.id] || [];
    return '<div class="cobbler-chatbot__issue-list">' + step.choices.map(function (choice) {
      var isActive = selected.indexOf(choice) !== -1;
      return '<button type="button" class="cobbler-chatbot__issue-choice' + (isActive ? " is-active" : "") + '" data-choice-step="' + escapeAttribute(step.id) + '" data-choice-value="' + escapeAttribute(choice) + '"><span class="cobbler-chatbot__issue-choice-icon" aria-hidden="true">' + renderShoeTypeIcon(choice) + '</span><span class="cobbler-chatbot__issue-choice-label">' + escapeHtml(shoeTypeLabels[choice] || choice) + '</span><span class="cobbler-chatbot__issue-choice-check" aria-hidden="true">' + (isActive ? "✓" : "") + '</span></button>';
    }).join("") + "</div>";
  }

  function renderShoeTypeIcon(value) {
    if (config.shoeTypeIconUrls[value]) {
      return '<img src="' + escapeAttribute(config.shoeTypeIconUrls[value]) + '" alt="" width="50" height="50" decoding="async" />';
    }

    return renderShoeContextIcon();
  }

  function renderIssueIcon(value) {
    if (config.issueIconUrls[value]) {
      return '<img src="' + escapeAttribute(config.issueIconUrls[value]) + '" alt="" width="50" height="50" decoding="async" />';
    }

    var paths = {
      "Talon use": '<path d="M6 4h7l3 8-4 3 5 5H7l3-5-4-3z"/>',
      "Semelle decollee": '<path d="M4 16c6 3 12 3 20-2l2 4c-8 6-16 5-23 1z"/><path d="M8 12l4 2m4-1 4 1"/>',
      "Cuir egratigne": '<path d="M5 6c5-3 13-3 20 1l-2 13c-7 3-13 2-20-2z"/><path d="m10 10 3 3-2 4m8-7-3 3 2 3"/>',
      "Couture ouverte": '<path d="M4 9h24M4 17h24"/><path d="m8 9 2 8m4-8 2 8m4-8 2 8"/>',
      "Nettoyage ou entretien": '<path d="m6 22 9-9m-6 6-3-3m9-5 5-5 3 3-5 5z"/><path d="M18 3v5m-3-2h6"/>',
      "Autre probleme": '<circle cx="16" cy="16" r="11"/><circle cx="11" cy="16" r="1" fill="currentColor"/><circle cx="16" cy="16" r="1" fill="currentColor"/><circle cx="21" cy="16" r="1" fill="currentColor"/>'
    };
    return '<svg viewBox="0 0 32 32" focusable="false" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">' + (paths[value] || paths["Autre probleme"]) + "</svg>";
  }

  function renderPairIllustration(pairCount) {
    var shoes = [];
    var shoeOutline = '<path fill="currentColor" opacity=".12" d="M4 28c4-4 8-9 10-14l5-8c2-3 5-4 8-2l10 7c4 3 6 7 10 9 5 2 13 2 19 6 4 2 6 5 7 8H5c-3 0-3-2-1-6Z" /><path d="M4 28c4-4 8-9 10-14l5-8c2-3 5-4 8-2l10 7c4 3 6 7 10 9 5 2 13 2 19 6 4 2 6 5 7 8H5c-3 0-3-2-1-6Z" /><path d="M5 34h64c3 0 4-1 4-3" /><path d="M17 13c5 4 10 7 17 8" /><path d="M20 10l10 7m-12-2 11 7m-13-1 11 7" /><path d="M20 8c3 2 6 3 9 3" /><path d="M46 20c2 5 5 9 9 13" /><path d="M13 17c3 5 7 8 12 10" />';
    for (var index = 0; index < pairCount; index += 1) {
      var offset = 2 + (index * 25);
      shoes.push('<g transform="translate(' + (offset + 10) + ' 1) scale(.54 .62)">' + shoeOutline + '</g>');
      shoes.push('<g transform="translate(' + offset + ' 13) scale(.66 .78)">' + shoeOutline + '</g>');
    }
    return '<svg viewBox="0 0 96 48" focusable="false"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2">' + shoes.join("") + "</g></svg>";
  }

  function renderPhotoSlots(imageStepId, files) {
    var slotLabels = ["Chaussure entière", "Problème en gros plan", "Semelle", "Angle supplémentaire", "Vue complémentaire"];
    var slots = [];

    for (var index = 0; index < config.maxImagesPerShoe; index += 1) {
      var file = files[index];
      if (file) {
        slots.push([
          '<div class="cobbler-chatbot__photo-slot is-filled">',
          file.previewUrl ? '<img src="' + escapeAttribute(file.previewUrl) + '" alt="' + escapeAttribute(slotLabels[index]) + '" />' : '<span class="cobbler-chatbot__photo-slot-placeholder" aria-hidden="true">⌁</span>',
          '  <span class="cobbler-chatbot__photo-slot-label">' + escapeHtml(slotLabels[index]) + "</span>",
          '  <button type="button" class="cobbler-chatbot__photo-slot-remove" data-remove-image-step="' + escapeAttribute(imageStepId) + '" data-remove-image-index="' + String(index) + '" aria-label="Retirer ' + escapeAttribute(file.name) + '">×</button>',
          "</div>"
        ].join(""));
      } else {
        slots.push([
          '<button type="button" class="cobbler-chatbot__photo-slot is-empty" data-image-pick="import" data-image-source-chooser="true" data-image-step="' + escapeAttribute(imageStepId) + '" data-image-slot-index="' + String(index) + '">',
          '  <span class="cobbler-chatbot__photo-slot-icon' + (index === 2 ? ' cobbler-chatbot__photo-slot-icon--sole' : '') + '" aria-hidden="true">' + renderPhotoSlotIcon(index) + '</span>',
          '  <span class="cobbler-chatbot__photo-slot-plus" aria-hidden="true">+</span>',
          '  <span class="cobbler-chatbot__photo-slot-label">' + escapeHtml(slotLabels[index]) + "</span>",
          "</button>"
        ].join(""));
      }
    }

    return '<div class="cobbler-chatbot__photo-grid">' + slots.join("") + "</div>";
  }

  function renderPhotoSlotIcon(index) {
    if (index === 1 && config.closeupImageUrl) {
      return '<img src="' + escapeAttribute(config.closeupImageUrl) + '" alt="" loading="lazy" />';
    }

    if (index === 2 && config.soleImageUrl) {
      return '<img src="' + escapeAttribute(config.soleImageUrl) + '" alt="" loading="lazy" />';
    }

    if (index === 3 && config.angleImageUrl) {
      return '<img src="' + escapeAttribute(config.angleImageUrl) + '" alt="" loading="lazy" />';
    }

    if (index === 0 && config.pairImages[0]) {
      return '<img src="' + escapeAttribute(config.pairImages[0]) + '" alt="" loading="lazy" />';
    }

    var icons = [
      '<path d="M3 18c4-2 7-6 9-12l2-3c1-2 3-2 5-1l5 5c2 2 4 3 6 4l1 5H4c-2 0-2-1-1-2Z"/><path d="M4 21h25"/>',
      '<circle cx="15" cy="14" r="7"/><path d="m20 19 7 7M12 14h6m-3-3v6"/>',
      '<path d="M11 4h10l2 23H9z"/><path d="M14 8h4m-5 4h6m-7 5h8m-9 4h10"/>',
      '<path d="M3 19c5-2 8-7 10-13l3-3 6 6c2 2 5 3 7 4l1 6H4c-1 0-2 0-1 0Z"/><path d="M5 22h23"/>',
      '<path d="M5 6h22v19H5z"/><path d="m8 20 5-5 3 3 3-4 5 6M10 11h.1"/>'
    ];
    return '<svg viewBox="0 0 30 30" focusable="false" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4">' + icons[index % icons.length] + "</svg>";
  }

  function renderPhotoActionIcon(url, fallback) {
    return url
      ? '<span class="cobbler-chatbot__photo-action-icon" aria-hidden="true"><img src="' + escapeAttribute(url) + '" alt="" /></span>'
      : '<span class="cobbler-chatbot__photo-action-icon" aria-hidden="true">' + fallback + '</span>';
  }

  function renderChoiceButtons(step) {
    return '<div class="cobbler-chatbot__choices">' + step.choices.map(function (choice) {
      var value = typeof choice === "string" ? choice : choice.value;
      var label = typeof choice === "string" ? choice : choice.label;
      var selectedValue = getPrimaryAnswer(step.id);
      var isActive = Array.isArray(selectedValue)
        ? selectedValue.indexOf(value) !== -1
        : selectedValue === value;
      return '<button type="button" class="cobbler-chatbot__choice' + (isActive ? " is-active" : "") + '" data-choice-step="' + step.id + '" data-choice-value="' + escapeAttribute(value) + '">' + escapeHtml(label) + "</button>";
    }).join("") + "</div>";
  }

  function renderChoiceCards(step) {
    return '<div class="cobbler-chatbot__choice-cards">' + step.choices.map(function (choice) {
      return [
        '<button type="button" class="cobbler-chatbot__choice-card' + (state.answers[step.id] === choice.value ? " is-active" : "") + '" data-choice-step="' + step.id + '" data-choice-value="' + escapeAttribute(choice.value) + '">',
        "  <strong>" + escapeHtml(choice.label) + "</strong>",
        "  <span>" + escapeHtml(choice.hint) + "</span>",
        "</button>"
      ].join("");
    }).join("") + "</div>";
  }

  function renderSummaryComposer() {
    var pairCards = [];
    for (var shoeIndex = 1; shoeIndex <= state.shoeCount; shoeIndex += 1) {
      pairCards.push(renderSummaryPairCard(shoeIndex));
    }
    return [
      '<div class="cobbler-chatbot__composer cobbler-chatbot__composer--summary">',
      '    <div class="cobbler-chatbot__summary-intro"><div class="cobbler-chatbot__step-kicker">Vérification</div><h3 class="cobbler-chatbot__step-title">Vérifie ta demande avant de l’envoyer.</h3><p>Tu recevras un devis avant toute intervention.</p></div>',
      pairCards.join(""),
      renderSummaryContactCard(),
      state.answers.additionalNotes ? renderSummaryRow("additionalNotes", formatAnswer("additionalNotes")) : "",
      renderUploadFailures(),
      state.submitPhase === "verifying" ? '  <div class="cobbler-chatbot__turnstile" data-turnstile-container aria-live="polite"></div>' : "",
      '  <div class="cobbler-chatbot__actions">',
      '    <button type="button" class="cobbler-chatbot__button cobbler-chatbot__button--secondary"' + (state.submitting ? " disabled" : "") + " data-prev>Retour</button>",
      '    <button type="button" class="cobbler-chatbot__button cobbler-chatbot__button--primary' + (state.submitting ? " is-loading" : "") + '"' + (state.submitting ? " disabled" : "") + " data-submit-summary>" + renderSubmitButtonLabel() + "</button>",
      "  </div>",
      "</div>"
    ].join("");
  }

  function renderSummaryPairCard(shoeIndex) {
    var files = state.answers["images_" + String(shoeIndex)] || [];
    var firstFile = getFirstSelectedFile(files);
    var preview = firstFile && firstFile.previewUrl;
    var galleryStep = { id: "images_" + String(shoeIndex), shoeIndex: shoeIndex };
    var isGalleryOpen = state.galleryStepId === galleryStep.id;
    var shoeType = formatAnswer("shoeType_" + String(shoeIndex));
    var issue = formatAnswer("issue_" + String(shoeIndex));
    return [
      '<details class="cobbler-chatbot__summary-pair" open>',
      '  <summary><span>PAIRE ' + String(shoeIndex) + '</span><span class="cobbler-chatbot__summary-chevron" aria-hidden="true">⌃</span></summary>',
      '  <div class="cobbler-chatbot__summary-pair-body">',
      '    <div class="cobbler-chatbot__summary-pair-top">',
      '<div class="cobbler-chatbot__summary-pair-image-trigger" data-pair-gallery-step="' + escapeAttribute(galleryStep.id) + '" role="button" tabindex="0" aria-expanded="' + String(isGalleryOpen) + '" aria-label="Voir les photos de la paire ' + String(shoeIndex) + '">' + (preview ? '<img class="cobbler-chatbot__summary-pair-image" src="' + escapeAttribute(preview) + '" alt="Voir les photos de la paire ' + String(shoeIndex) + '" />' : '<span class="cobbler-chatbot__summary-pair-image cobbler-chatbot__summary-pair-image--empty" aria-hidden="true">' + renderShoeTypeIcon("Chaussures habillees") + '</span>') + '</div>',
      '    <div class="cobbler-chatbot__summary-pair-meta"><strong>' + String(countSelectedFiles(files)) + ' photo' + (countSelectedFiles(files) === 1 ? '' : 's') + '</strong><small>' + escapeHtml(shoeType || "Type non précisé") + '</small><span>Services sélectionnés</span><div class="cobbler-chatbot__summary-services">' + escapeHtml(issue || "Aucun service sélectionné") + '</div></div>',
      '    </div>',
      isGalleryOpen ? renderPairPhotoGallery(galleryStep, files) : "",
      '    <div class="cobbler-chatbot__summary-pair-actions"><button type="button" class="cobbler-chatbot__summary-edit" data-edit-step="images_' + String(shoeIndex) + '">Modifier les photos</button><button type="button" class="cobbler-chatbot__summary-edit" data-edit-step="issue_' + String(shoeIndex) + '">Modifier le service</button></div>',
      '  </div>',
      '</details>'
    ].join("");
  }

  function renderSummaryContactCard() {
    return [
      '<div class="cobbler-chatbot__summary-contact">',
      '  <div class="cobbler-chatbot__summary-contact-heading"><strong>COORDONNÉES</strong><button type="button" class="cobbler-chatbot__summary-edit" data-edit-step="customerName">Modifier</button></div>',
      '  <div class="cobbler-chatbot__summary-contact-body"><span class="cobbler-chatbot__summary-contact-icon" aria-hidden="true">♙</span><div><strong>' + escapeHtml(formatAnswer("customerName") || "Nom non précisé") + '</strong><span>' + escapeHtml(formatAnswer("customerPhone") || "Téléphone non précisé") + '</span><span>' + escapeHtml(formatAnswer("customerEmail") || "Email non précisé") + '</span></div></div>',
      '</div>'
    ].join("");
  }

  function renderUploadFailures() {
    if (!state.uploadFailures.length) {
      return "";
    }

    return [
      '<div class="cobbler-chatbot__upload-failures" role="alert">',
      '  <strong>Photos à réessayer</strong>',
      state.uploadFailures.map(function (failure) {
        return [
          '  <div class="cobbler-chatbot__upload-failure">',
          '    <span><span class="cobbler-chatbot__upload-failure-name">' + escapeHtml(failure.task.file.name) + '</span><span class="cobbler-chatbot__upload-failure-message">' + escapeHtml(failure.message) + "</span></span>",
          '    <button type="button" class="cobbler-chatbot__button cobbler-chatbot__button--secondary cobbler-chatbot__upload-retry" data-retry-upload-key="' + escapeAttribute(failure.task.key) + '"' + (state.submitting ? " disabled" : "") + '>Réessayer cette photo</button>',
          "  </div>"
        ].join("");
      }).join(""),
      "</div>"
    ].join("");
  }

  function renderSubmitButtonLabel() {
    if (!state.submitting) {
      return "Envoyer";
    }

    if (state.submitPhase === "uploading") {
      return '<span class="cobbler-chatbot__button-spinner" aria-hidden="true"></span>Envoi des photos...';
    }

    if (state.submitPhase === "verifying") {
      return '<span class="cobbler-chatbot__button-spinner" aria-hidden="true"></span>Vérification...';
    }

    return '<span class="cobbler-chatbot__button-spinner" aria-hidden="true"></span>Envoi en cours...';
  }

  function renderSelectedFiles(imageStepId) {
    var files = state.answers[imageStepId] || [];
    return [
      '<div class="cobbler-chatbot__file-list">',
      files.map(function (file, index) {
        return [
          '<div class="cobbler-chatbot__file-pill">',
          '  <span class="cobbler-chatbot__file-pill-name">' + escapeHtml(file.name) + "</span>",
          '  <button type="button" class="cobbler-chatbot__file-pill-remove" data-remove-image-step="' + escapeAttribute(imageStepId) + '" data-remove-image-index="' + String(index) + '" aria-label="' + escapeAttribute("Retirer " + file.name) + '">x</button>',
          "</div>"
        ].join("");
      }).join(""),
      "</div>",
      '<div class="cobbler-chatbot__microcopy">' + countSelectedFiles(files) + " fichier(s) sélectionné(s)</div>"
    ].join("");
  }

  function renderSummaryRow(stepId, value) {
    return [
      '<div class="cobbler-chatbot__summary-row">',
      "  <div>",
      "    <strong>" + escapeHtml(answerLabels[stepId] || stepId) + "</strong>",
      "    <div>" + escapeHtml(value || "-") + "</div>",
      "  </div>",
      '  <button type="button" class="cobbler-chatbot__summary-edit" data-edit-step="' + escapeAttribute(stepId) + '">Modifier</button>',
      "</div>"
    ].join("");
  }

  function isMobilePhotoViewport() {
    return window.innerWidth <= 640 || (window.matchMedia && window.matchMedia("(max-width: 640px)").matches);
  }

  function openImageSourcePicker(picker) {
    if (!picker) {
      return;
    }

    picker.hidden = false;
    picker.setAttribute("aria-hidden", "false");
    var dialog = picker.querySelector(".cobbler-chatbot__photo-source-dialog");
    if (dialog) {
      dialog.focus();
    }
  }

  function closeImageSourcePicker(picker) {
    if (!picker) {
      return;
    }

    picker.hidden = true;
    picker.setAttribute("aria-hidden", "true");
  }

  function renderActions(step) {
    var showBack = getFlowPosition() > 1;

    if (step.id === "shoeCount") {
      return '<div class="cobbler-chatbot__actions cobbler-chatbot__actions--single"><button type="button" class="cobbler-chatbot__button cobbler-chatbot__button--primary" data-next>Continuer</button></div>';
    }

    if (step.type === "choice-cards" || step.type === "choice-with-skip" || step.type === "add-shoe") {
      return '<div class="cobbler-chatbot__actions ' + (showBack ? "cobbler-chatbot__actions--navigation" : "cobbler-chatbot__actions--single") + '">' + (showBack ? '<button type="button" class="cobbler-chatbot__button cobbler-chatbot__button--secondary" data-prev>Retour</button>' : "") + "</div>";
    }

    return '<div class="cobbler-chatbot__actions ' + (showBack ? "cobbler-chatbot__actions--navigation" : "cobbler-chatbot__actions--single") + '">' + (showBack ? '<button type="button" class="cobbler-chatbot__button cobbler-chatbot__button--secondary" data-prev>Retour</button>' : "") + '<button type="button" class="cobbler-chatbot__button cobbler-chatbot__button--primary" data-next>Continuer</button></div>';
  }

  function renderStatus() {
    if (!state.status.message) {
      return "";
    }

    return '<p class="cobbler-chatbot__status' + (state.status.tone ? " is-" + state.status.tone : "") + '">' + escapeHtml(state.status.message) + "</p>";
  }

  function bind() {
    var launcher = root.querySelector("[data-launcher]");
    var closeButton = root.querySelector("[data-close]");
    var resetButton = root.querySelector("[data-reset]");
    var nextButton = root.querySelector("[data-next]");
    var prevButton = root.querySelector("[data-prev]");
    var submitSummaryButton = root.querySelector("[data-submit-summary]");
    var doneButton = root.querySelector("[data-done]");
    var currentField = root.querySelector("[data-field]");
    var fileInputs = root.querySelectorAll("[data-image-input]");
    var imageSourcePicker = root.querySelector("[data-image-source-picker]");

    launcher.addEventListener("click", function () {
      if (state.isOpen) {
        closeChatbot();
      } else {
        openChatbot();
      }
    });

    if (closeButton) {
      closeButton.addEventListener("click", function () {
        closeChatbot();
      });
    }

    if (resetButton) {
      resetButton.addEventListener("click", function () {
        if (state.submitting) {
          return;
        }

        resetFlow();
      });
    }

    root.querySelectorAll("[data-choice-step]").forEach(function (button) {
      button.addEventListener("click", function () {
        var stepId = button.getAttribute("data-choice-step");
        var value = button.getAttribute("data-choice-value");
        clearStatus();

        if (isIssueStep(stepId)) {
          toggleMultiSelectAnswer(stepId, value);
          if ((state.answers[stepId] || []).indexOf("Autre probleme") === -1) {
            state.answers[getIssueDetailKey(stepId)] = "";
          }
          requestScrollToBottom();
          renderApp();
          return;
        }

        if (isShoeTypeStep(stepId)) {
          toggleMultiSelectAnswer(stepId, value);
          if ((state.answers[stepId] || []).indexOf("Autre") === -1) {
            state.answers[getShoeTypeDetailKey(stepId)] = "";
          }
          requestScrollToBottom();
          renderApp();
          return;
        }

        if (stepId === "shoeCount") {
          state.shoeCount = Number(value);
          requestScrollToBottom();
          renderApp();
          return;
        }

        if (isAddShoeStep(stepId)) {
          var targetShoe = parseAddShoeTarget(stepId);
          if (value === "yes") {
            state.shoeCount = Math.max(state.shoeCount, targetShoe);
          } else {
            state.shoeCount = Math.max(1, targetShoe - 1);
          }
          requestScrollToBottom();
          nextStep();
          return;
        }

        renderApp();
      });
    });

    root.querySelectorAll("[data-edit-step]").forEach(function (button) {
      button.addEventListener("click", function () {
        jumpToStep(button.getAttribute("data-edit-step"), true);
      });
    });

    root.querySelectorAll("[data-pair-gallery-step]").forEach(function (button) {
      function togglePairGallery() {
        var stepId = button.getAttribute("data-pair-gallery-step") || "";
        state.galleryStepId = state.galleryStepId === stepId ? null : stepId;
        renderApp();
      }

      button.addEventListener("click", togglePairGallery);
      button.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          togglePairGallery();
        }
      });
    });

    root.querySelectorAll("[data-pair-gallery-close]").forEach(function (button) {
      button.addEventListener("click", function () {
        state.galleryStepId = null;
        renderApp();
      });
    });

    root.querySelectorAll("[data-remove-image-index]").forEach(function (button) {
      button.addEventListener("click", function () {
        var stepId = button.getAttribute("data-remove-image-step") || "";
        var index = Number(button.getAttribute("data-remove-image-index"));
        if (Number.isNaN(index) || !stepId) {
          return;
        }

        removeSelectedImage(stepId, index);
        clearStatus();
        renderApp();
      });
    });

    root.querySelectorAll("[data-retry-upload-key]").forEach(function (button) {
      button.addEventListener("click", function () {
        retryFailedUpload(button.getAttribute("data-retry-upload-key") || "");
      });
    });

    root.querySelectorAll("[data-pair-image]").forEach(function (image) {
      image.addEventListener("error", function () {
        image.hidden = true;
        var fallback = image.parentElement && image.parentElement.querySelector("[data-pair-image-fallback]");
        if (fallback) {
          fallback.hidden = false;
        }
      });
    });

    if (currentField) {
      currentField.addEventListener("input", function () {
        var field = currentField.getAttribute("data-field");
        updateFieldValue(field, currentField.value);
        if (field === "customerPhone" && state.phoneTooLong) {
          setStatus("Ce numéro est trop long. Saisis 10 chiffres après le +1.", "error");
          renderApp();
        } else if (field === "customerPhone" && state.status.message === "Ce numéro est trop long. Saisis 10 chiffres après le +1.") {
          clearStatus();
          renderApp();
        }
      });
    }

    root.querySelectorAll("[data-image-pick]").forEach(function (button) {
      button.addEventListener("click", function () {
        var inputMode = button.getAttribute("data-image-pick") || "import";
        var imageStepId = button.getAttribute("data-image-step") || "";
        var files = state.answers[imageStepId] || [];
        var requestedSlot = button.getAttribute("data-image-slot-index");
        var slotIndex = requestedSlot === null ? findFirstEmptyImageSlot(files) : Number(requestedSlot);
        state.activeImageSlot = imageStepId && Number.isInteger(slotIndex)
          ? { stepId: imageStepId, index: slotIndex }
          : null;

        if (button.getAttribute("data-image-source-chooser") === "true" && isMobilePhotoViewport()) {
          openImageSourcePicker(imageSourcePicker);
          return;
        }

        var input = root.querySelector('[data-image-input="' + inputMode + '"]');
        if (input) {
          input.click();
        }
      });
    });

    root.querySelectorAll("[data-image-source-close]").forEach(function (button) {
      button.addEventListener("click", function () {
        closeImageSourcePicker(imageSourcePicker);
      });
    });

    root.querySelectorAll("[data-image-source]").forEach(function (button) {
      button.addEventListener("click", function () {
        var inputMode = button.getAttribute("data-image-source") || "import";
        closeImageSourcePicker(imageSourcePicker);
        var input = root.querySelector('[data-image-input="' + inputMode + '"]');
        if (input) {
          input.click();
        }
      });
    });

    if (imageSourcePicker) {
      imageSourcePicker.querySelector(".cobbler-chatbot__photo-source-dialog").addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
          closeImageSourcePicker(imageSourcePicker);
        }
      });
    }

    fileInputs.forEach(function (fileInput) {
      fileInput.addEventListener("change", function () {
        var step = getCurrentStep();
        if (!step || step.type !== "images") {
          return;
        }

        var imageKey = step.id;
        var existingFiles = state.answers[imageKey] || [];
        var incomingFiles = Array.prototype.slice.call(fileInput.files || []);

        var existingImageCount = countSelectedFiles(existingFiles);
        var remainingGlobalSlots = Math.max(0, config.maxImagesTotal - (getTotalSelectedImages() - existingImageCount));
        var maxForCurrentShoe = Math.min(config.maxImagesPerShoe, remainingGlobalSlots);
        var bytesOutsideCurrentShoe = getTotalSelectedImageBytes() - getFilesSize(existingFiles);
        var maxBytesForCurrentShoe = Math.max(0, config.maxUploadTotalBytes - bytesOutsideCurrentShoe);

        var targetSlot = state.activeImageSlot && state.activeImageSlot.stepId === imageKey
          ? state.activeImageSlot.index
          : null;
        var mergeResult = mergeSelectedImages(existingFiles, incomingFiles, maxForCurrentShoe, maxBytesForCurrentShoe, targetSlot);
        state.activeImageSlot = null;
        state.answers[imageKey] = mergeResult.files;
        pruneUploadState();

        if (mergeResult.skippedLimit > 0) {
          setStatus("Limite atteinte pour cette chaussure ou pour la demande globale.", "error");
        } else if (mergeResult.skippedTypeNames.length > 0) {
          setStatus("Format non pris en charge : " + mergeResult.skippedTypeNames.join(", ") + ". Choisis une image JPEG, PNG, WebP ou HEIC.", "error");
        } else if (mergeResult.skippedFileSize > 0) {
          setStatus("Cette photo dépasse la limite de " + config.maxUploadFileMb + " Mo. Choisis une photo plus légère.", "error");
        } else if (mergeResult.skippedSize > 0) {
          setStatus("Le poids total des photos ne peut pas dépasser " + config.maxUploadTotalMb + " Mo.", "error");
        } else {
          clearStatus();
        }

        fileInput.value = "";
        renderApp();
      });
    });

    if (nextButton) {
      nextButton.addEventListener("click", function () {
        handleCurrentStep();
      });
    }

    if (prevButton) {
      prevButton.addEventListener("click", function () {
        if (state.submitting) {
          return;
        }

        previousStep();
      });
    }

    if (submitSummaryButton) {
      submitSummaryButton.addEventListener("click", function () {
        submit();
      });
    }

    if (doneButton) {
      doneButton.addEventListener("click", function () {
        state.isOpen = false;
        renderApp();
      });
    }
  }

  function updateFieldValue(field, value) {
    if (isIssueStep(field)) {
      state.answers[getIssueDetailKey(field)] = value.trim();
      return;
    }

    if (isShoeTypeStep(field)) {
      state.answers[getShoeTypeDetailKey(field)] = value.trim();
      return;
    }

    if (field === "customerPhone") {
      var phoneDigits = String(value || "").replace(/\D/g, "");
      state.phoneTooLong = phoneDigits.length > 11;
      state.answers.customerPhone = formatCanadaPhoneInput(value);
      return;
    }

    state.answers[field] = value.trim();
  }

  function handleCurrentStep() {
    clearStatus();

    if (!validateCurrentStep()) {
      renderApp();
      return;
    }

    if (state.returnToSummary) {
      if (isContactStep(state.currentStepIndex)) {
        nextStep();
        return;
      }

      state.currentStepIndex = steps.findIndex(function (step) {
        return step.id === "summary";
      });
      state.returnToSummary = false;
      clearStepPromptDelay();
      renderApp();
      return;
    }

    nextStep();
  }

  function validateCurrentStep() {
    var step = getCurrentStep();

    if (!step) {
      return true;
    }

    if (step.type === "images") {
      var files = state.answers[step.id] || [];

      if (config.uploadMode !== "upload-endpoint" || !config.uploadEndpoint) {
        setStatus("Le téléversement des images n’est pas configuré.", "error");
        return false;
      }

      var selectedFileCount = countSelectedFiles(files);
      if (selectedFileCount < config.minImagesPerShoe) {
        setStatus("Ajoute au moins " + config.minImagesPerShoe + " photo pour cette chaussure.", "error");
        return false;
      }

      if (selectedFileCount > config.maxImagesPerShoe) {
        setStatus("Limite cette chaussure à " + config.maxImagesPerShoe + " photos maximum.", "error");
        return false;
      }

      if (getTotalSelectedImages() > config.maxImagesTotal) {
        setStatus("Limite la demande à " + config.maxImagesTotal + " photos maximum.", "error");
        return false;
      }

      if (getTotalSelectedImageBytes() > config.maxUploadTotalBytes) {
        setStatus("Le poids total des photos ne peut pas dépasser " + config.maxUploadTotalMb + " Mo.", "error");
        return false;
      }
    }

    if (isIssueStep(step.id)) {
      if (!(state.answers[step.id] || []).length) {
        setStatus("Choisis d’abord le problème à résoudre.", "error");
        return false;
      }

      if ((state.answers[step.id] || []).indexOf("Autre probleme") !== -1 && !state.answers[getIssueDetailKey(step.id)]) {
        setStatus("Décris le problème rencontré.", "error");
        return false;
      }
    }

    if (isShoeTypeStep(step.id)) {
      if (!(state.answers[step.id] || []).length) {
        setStatus("Choisis d’abord le type de chaussures.", "error");
        return false;
      }

      if ((state.answers[step.id] || []).indexOf("Autre") !== -1 && !state.answers[getShoeTypeDetailKey(step.id)]) {
        setStatus("Précise le type de chaussures.", "error");
        return false;
      }
    }

    if (step.id === "customerName" && !state.answers.customerName) {
      setStatus("Le prénom et le nom sont obligatoires.", "error");
      return false;
    }

    if (step.id === "customerPhone") {
      if (state.phoneTooLong) {
        setStatus("Ce numéro est trop long. Saisis 10 chiffres après le +1.", "error");
        return false;
      }

      if (!state.answers.customerPhone) {
        setStatus("Le numéro de téléphone est obligatoire.", "error");
        return false;
      }

      if (!isValidCanadaPhone(state.answers.customerPhone)) {
        setStatus("Ce numéro ne semble pas valide. Vérifie l’indicatif régional et les 10 chiffres, puis réessaie.", "error");
        return false;
      }
    }

    if (step.id === "customerEmail") {
      if (!state.answers.customerEmail) {
        setStatus("L'adresse email est obligatoire.", "error");
        return false;
      }

      if (!isValidEmail(state.answers.customerEmail)) {
        setStatus("Merci de saisir une adresse email valide.", "error");
        return false;
      }
    }

    return true;
  }

  function nextStep() {
    state.introVisibleCount = 2;
    requestScrollToBottom();
    var nextIndex = state.currentStepIndex + 1;

    while (nextIndex < steps.length && shouldSkipStep(steps[nextIndex])) {
      nextIndex += 1;
    }

    state.currentStepIndex = Math.min(nextIndex, steps.length - 1);
    startStepPromptDelay();
    renderApp();
  }

  function previousStep() {
    var previousIndex = state.currentStepIndex - 1;

    while (previousIndex >= 0 && shouldSkipStep(steps[previousIndex])) {
      previousIndex -= 1;
    }

    state.currentStepIndex = Math.max(previousIndex, 0);
    state.returnToSummary = false;
    clearStatus();
    startStepPromptDelay();
    renderApp();
  }

  function jumpToStep(stepId, returnToSummary) {
    var index = steps.findIndex(function (step) {
      return step.id === stepId;
    });

    if (index >= 0) {
      state.currentStepIndex = index;
      state.returnToSummary = Boolean(returnToSummary);
      clearStatus();
      startStepPromptDelay();
      renderApp();
    }
  }

  function shouldSkipStep(step) {
    if (!step) {
      return true;
    }

    if (step.shoeIndex && step.shoeIndex > state.shoeCount) {
      return true;
    }

    if (step.type === "add-shoe") {
      return state.shoeCount < step.triggerIndex;
    }

    return false;
  }

  function getCurrentStep() {
    return steps[state.currentStepIndex];
  }

  function getVisibleNonSummarySteps() {
    return steps.filter(function (step) {
      return !shouldSkipStep(step) && step.id !== "summary";
    });
  }

  function getFlowLength() {
    return Math.max(1, getVisibleNonSummarySteps().length);
  }

  function getFlowPosition() {
    var current = getCurrentStep();
    var visible = getVisibleNonSummarySteps();

    if (!current) {
      return 1;
    }

    if (current.id === "summary") {
      return visible.length;
    }

    for (var index = 0; index < visible.length; index += 1) {
      if (visible[index].id === current.id) {
        return index + 1;
      }
    }

    return 1;
  }

  function getPrimaryAnswer(stepId) {
    if (stepId === "shoeCount") {
      return String(state.shoeCount);
    }
    return state.answers[stepId] || (isMultiSelectStep(stepId) ? [] : "");
  }

  function getOtherAnswer(stepId) {
    if (isIssueStep(stepId)) {
      return state.answers[getIssueDetailKey(stepId)] || "";
    }

    if (isShoeTypeStep(stepId)) {
      return state.answers[getShoeTypeDetailKey(stepId)] || "";
    }

    return "";
  }

  function formatAnswer(stepId) {
    if (stepId === "shoeCount") {
      return state.shoeCount + " paire" + (state.shoeCount > 1 ? "s" : "");
    }

    if (isIssueStep(stepId)) {
      return buildIssueSummaryText(stepId);
    }

    if (isShoeTypeStep(stepId)) {
      return buildShoeTypeSummaryText(stepId);
    }

    if (stepId === "additionalNotes") {
      return state.answers.additionalNotes || "Aucun détail supplémentaire";
    }

    if (isImageStep(stepId)) {
      var files = state.answers[stepId] || [];
      var selectedFileCount = countSelectedFiles(files);
      return selectedFileCount + " photo" + (selectedFileCount > 1 ? "s" : "") + " sélectionnée" + (selectedFileCount > 1 ? "s" : "");
    }

    if (isAddShoeStep(stepId)) {
      return state.shoeCount >= parseAddShoeTarget(stepId) ? "Oui" : "Non";
    }

    return state.answers[stepId] || "-";
  }

  async function submit() {
    clearStatus();
    pruneUploadState();

    if (getTotalSelectedImages() > config.maxImagesTotal) {
      setStatus("Limite la demande à " + config.maxImagesTotal + " photos maximum.", "error");
      renderApp();
      return;
    }

    if (getTotalSelectedImageBytes() > config.maxUploadTotalBytes) {
      setStatus("Le poids total des photos ne peut pas dépasser " + config.maxUploadTotalMb + " Mo.", "error");
      renderApp();
      return;
    }

    state.submitting = true;
    state.submitPhase = "uploading";
    state.uploadedImageCount = 0;
    var totalSelected = getTotalSelectedImages();
    setStatus(buildUploadStatusMessage(0, totalSelected), "");
    requestScrollToBottom();
    renderApp();

    try {
      if (!config.webhookUrl) {
        throw new Error("Le webhook n8n n’est pas configuré.");
      }

      state.submitPhase = "sending";
      setStatus("Envoi de la demande en cours…", "");
      renderApp();

      var payload = await buildPayload();
      var response = await sendPayload(payload);
      var result = response.result;

      if (response.status === 403 && result && (result.errorCode === "turnstile_required" || result.errorCode === "turnstile_failed")) {
        state.submitPhase = "verifying";
        setStatus("Vérification de sécurité en cours…", "");
        renderApp();
        payload.turnstileToken = await requestTurnstileToken();
        destroyTurnstileWidget();
        state.submitPhase = "sending";
        setStatus("Envoi de la demande en cours…", "");
        renderApp();
        response = await sendPayload(payload);
        result = response.result;
      }

      if (!response.ok && response.status !== 202) {
        throw new Error(buildErrorMessage(response.status, result));
      }

      state.requestNumber = result.requestNumber || null;
      state.submitting = false;
      state.completed = true;
      state.submitPhase = "";
      requestScrollToBottom();

      if (result.duplicateDetected) {
        setStatus("Une demande similaire a déjà été reçue" + (state.requestNumber ? " (" + state.requestNumber + ")" : "") + ".", "success");
      } else if (response.status === 202 || result.partialFailure || result.accepted) {
        setStatus("Ta demande est bien enregistrée" + (state.requestNumber ? " (" + state.requestNumber + ")" : "") + ".", "success");
      } else {
        setStatus("Ta demande a bien été envoyée" + (state.requestNumber ? " (" + state.requestNumber + ")" : "") + ".", "success");
      }

      renderApp();
    } catch (error) {
      destroyTurnstileWidget();
      state.submitting = false;
      state.submitPhase = "";
      setStatus(
        error.isUploadFailure
          ? error.message
          : "Impossible d’envoyer la demande pour le moment. " + error.message,
        "error"
      );
      requestScrollToBottom();
      renderApp();
    }
  }

  async function sendPayload(payload) {
    var response = await fetch(config.webhookUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    return {
      ok: response.ok,
      status: response.status,
      result: await parseResponse(response)
    };
  }

  function loadTurnstileScript() {
    if (window.turnstile) {
      return Promise.resolve(window.turnstile);
    }

    if (turnstileScriptPromise) {
      return turnstileScriptPromise;
    }

    turnstileScriptPromise = new Promise(function (resolve, reject) {
      var script = document.getElementById("cobbler-turnstile-api");
      var timeoutId = window.setTimeout(function () {
        removeUnusableScript();
        turnstileScriptPromise = null;
        reject(new Error("La vérification de sécurité a expiré. Réessaie."));
      }, 20000);

      function removeUnusableScript() {
        if (script && script.parentNode && !window.turnstile) {
          script.parentNode.removeChild(script);
        }
      }

      function finish() {
        window.clearTimeout(timeoutId);
        if (window.turnstile) {
          resolve(window.turnstile);
        } else {
          removeUnusableScript();
          turnstileScriptPromise = null;
          reject(new Error("La vérification de sécurité est indisponible."));
        }
      }

      function fail() {
        window.clearTimeout(timeoutId);
        removeUnusableScript();
        turnstileScriptPromise = null;
        reject(new Error("Impossible de charger la vérification de sécurité."));
      }

      if (script) {
        script.addEventListener("load", finish, { once: true });
        script.addEventListener("error", fail, { once: true });
        return;
      }

      script = document.createElement("script");
      script.id = "cobbler-turnstile-api";
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      script.async = true;
      script.defer = true;
      script.addEventListener("load", finish, { once: true });
      script.addEventListener("error", fail, { once: true });
      document.head.appendChild(script);
    });

    return turnstileScriptPromise;
  }

  async function requestTurnstileToken() {
    if (!config.turnstileSitekey) {
      throw new Error("La vérification de sécurité n’est pas configurée.");
    }

    var turnstile = await loadTurnstileScript();
    var container = root.querySelector("[data-turnstile-container]");

    if (!container) {
      throw new Error("La vérification de sécurité ne peut pas démarrer.");
    }

    return new Promise(function (resolve, reject) {
      var settled = false;
      var timeoutId = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        reject(new Error("La vérification de sécurité a expiré. Réessaie."));
      }, 30000);

      function succeed(token) {
        if (settled) return;
        if (!token) {
          fail();
          return;
        }
        settled = true;
        window.clearTimeout(timeoutId);
        resolve(token);
      }

      function fail() {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeoutId);
        reject(new Error("La vérification de sécurité a échoué. Réessaie."));
      }

      try {
        activeTurnstileWidgetId = turnstile.render(container, {
          sitekey: config.turnstileSitekey,
          action: "cobbler_intake",
          execution: "execute",
          appearance: "interaction-only",
          size: "flexible",
          "response-field": false,
          "refresh-expired": "manual",
          callback: succeed,
          "error-callback": fail,
          "expired-callback": fail,
          "timeout-callback": fail
        });
        turnstile.execute(container);
      } catch (error) {
        fail();
      }
    });
  }

  function destroyTurnstileWidget() {
    if (activeTurnstileWidgetId !== null && window.turnstile) {
      try {
        window.turnstile.remove(activeTurnstileWidgetId);
      } catch (error) {
        // The widget container may already have been replaced by a render.
      }
    }
    activeTurnstileWidgetId = null;
  }

  async function buildPayload() {
    var uploaded = await uploadShoeFiles();
    var shoes = uploaded.shoes;
    var flatImages = uploaded.flatImages;

    var shoeTypeSummary = shoes.map(function (shoe) {
      return "S" + String(shoe.shoeIndex) + ": " + shoe.shoeType;
    }).join(" | ");

    var issueSummary = shoes.map(function (shoe) {
      return "S" + String(shoe.shoeIndex) + ": " + shoe.issue;
    }).join(" | ");

    return {
      schemaVersion: "1.1",
      sessionId: state.sessionId,
      source: "shopify-chatbot",
      submittedAt: new Date().toISOString(),
      store: {
        domain: config.storeDomain,
        pageUrl: config.pageUrl
      },
      customer: {
        name: state.answers.customerName.trim(),
        email: state.answers.customerEmail.trim(),
        phone: normalizeCanadaPhoneForPayload(state.answers.customerPhone),
        preferredContactMethod: "email"
      },
      repair: {
        shoeType: shoeTypeSummary,
        issue: issueSummary,
        urgency: "Standard",
        additionalNotes: state.answers.additionalNotes.trim()
      },
      shoes: shoes,
      images: flatImages
    };
  }

  function getOrCreateSessionId() {
    var storageKey = "cobbler-chatbot-session-id";
    var existing = "";

    try {
      existing = String(window.sessionStorage.getItem(storageKey) || "").trim();
    } catch (_error) {
      existing = "";
    }

    if (existing) {
      return existing;
    }

    var generated = "";
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      generated = window.crypto.randomUUID();
    } else if (window.crypto && typeof window.crypto.getRandomValues === "function") {
      var bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      generated = Array.prototype.map.call(bytes, function (value) {
        return value.toString(16).padStart(2, "0");
      }).join("");
    } else {
      generated = String(Date.now()) + "-" + Math.random().toString(36).slice(2);
    }

    try {
      window.sessionStorage.setItem(storageKey, generated);
    } catch (_error) {
      // A private browsing context may reject sessionStorage; the in-memory ID remains valid.
    }

    return generated;
  }

  async function uploadShoeFiles() {
    var tasks = buildUploadTasks();
    var totalImages = tasks.length;
    var completed = tasks.filter(function (task) {
      return Boolean(state.uploadCache[task.key]);
    }).length;
    var pendingTasks = tasks.filter(function (task) {
      return !state.uploadCache[task.key];
    });
    var nextTaskIndex = 0;

    state.uploadFailures = [];
    state.uploadedImageCount = completed;
    setStatus(buildUploadStatusMessage(completed, totalImages), "");
    renderApp();

    async function worker() {
      while (nextTaskIndex < pendingTasks.length) {
        var taskIndex = nextTaskIndex;
        nextTaskIndex += 1;
        var task = pendingTasks[taskIndex];

        try {
          state.uploadCache[task.key] = await uploadSingleFileWithRetry(task);
          completed += 1;
          state.uploadedImageCount = completed;
          setStatus(buildUploadStatusMessage(completed, totalImages), "");
        } catch (error) {
          state.uploadFailures.push({
            task: task,
            message: error.message
          });
        }

        renderApp();
      }
    }

    var workerCount = Math.min(2, pendingTasks.length);
    var workers = [];
    for (var workerIndex = 0; workerIndex < workerCount; workerIndex += 1) {
      workers.push(worker());
    }
    await Promise.all(workers);

    if (state.uploadFailures.length) {
      var failureCount = state.uploadFailures.length;
      var uploadFailure = new Error(
        failureCount + " photo" + (failureCount > 1 ? "s n’ont pas pu être téléversées" : " n’a pas pu être téléversée") +
        ". Réessaie uniquement " + (failureCount > 1 ? "les photos indiquées" : "la photo indiquée") + "."
      );
      uploadFailure.isUploadFailure = true;
      throw uploadFailure;
    }

    var shoes = [];
    var flatImages = [];
    for (var shoeIndex = 1; shoeIndex <= state.shoeCount; shoeIndex += 1) {
      var uploadedImages = tasks.filter(function (task) {
        return task.shoeIndex === shoeIndex;
      }).map(function (task) {
        var uploadResult = state.uploadCache[task.key];
        var image = {
          url: getUploadedImageUrl(uploadResult),
          label: "S" + String(shoeIndex) + " - " + task.file.name,
          shoeIndex: shoeIndex
        };
        flatImages.push(image);
        return image;
      });

      shoes.push({
        shoeIndex: shoeIndex,
        shoeType: buildShoeTypePayloadText("shoeType_" + String(shoeIndex)).trim(),
        issue: buildIssuePayloadText("issue_" + String(shoeIndex)).trim(),
        additionalNotes: "",
        images: uploadedImages
      });
    }

    return {
      shoes: shoes,
      flatImages: flatImages
    };
  }

  function buildUploadTasks() {
    var tasks = [];
    var globalIndex = 0;

    for (var shoeIndex = 1; shoeIndex <= state.shoeCount; shoeIndex += 1) {
      var files = state.answers["images_" + String(shoeIndex)] || [];
      for (var fileIndex = 0; fileIndex < files.length; fileIndex += 1) {
        var file = files[fileIndex];
        if (!file) {
          continue;
        }
        tasks.push({
          key: buildUploadTaskKey(shoeIndex, file),
          shoeIndex: shoeIndex,
          fileIndex: fileIndex,
          globalIndex: globalIndex,
          file: file
        });
        globalIndex += 1;
      }
    }

    return tasks;
  }

  async function uploadSingleFileWithRetry(task) {
    var maxAttempts = 3;
    var lastError;
    var uploadId = task.uploadId || createUploadTraceId();
    task.uploadId = uploadId;

    for (var attempt = 1; attempt <= maxAttempts; attempt += 1) {
      try {
        return await uploadSingleFile(task.file, task.globalIndex, uploadId, attempt);
      } catch (error) {
        lastError = error;
        if (!error.retryable || attempt === maxAttempts) {
          throw error;
        }
        await wait(750 * Math.pow(2, attempt - 1));
      }
    }

    throw lastError;
  }

  async function uploadSingleFile(file, globalIndex, uploadId, attempt) {
    if (!config.uploadEndpoint) {
      throw new Error("Aucun endpoint de téléversement n’est configuré.");
    }

    var formData = new FormData();
    formData.append("file", file, file.name);
    formData.append("fileIndex", String(globalIndex));

    var controller = new AbortController();
    var timedOut = false;
    var timeoutId = window.setTimeout(function () {
      timedOut = true;
      controller.abort();
    }, config.uploadTimeoutMs);
    var response;

    try {
      response = await fetch(config.uploadEndpoint, {
        method: "POST",
        body: formData,
        headers: {
          "X-Cobbler-Upload-ID": uploadId,
          "X-Cobbler-File-Index": String(globalIndex),
          "X-Cobbler-File-Size": String(file.size || 0),
          "X-Cobbler-Upload-Attempt": String(attempt || 1)
        },
        signal: controller.signal
      });
    } catch (error) {
      var networkError = new Error(
        timedOut
          ? "Le téléversement a dépassé " + Math.round(config.uploadTimeoutMs / 1000) + " secondes. Référence " + uploadId.slice(0, 8) + "."
          : "Le téléversement a été interrompu. Réessaie cette photo. Référence " + uploadId.slice(0, 8) + "."
      );
      networkError.retryable = true;
      networkError.errorCode = timedOut ? "upload_timeout" : "upload_network_error";
      networkError.uploadId = uploadId;
      throw networkError;
    } finally {
      window.clearTimeout(timeoutId);
    }

    var result = await parseResponse(response);

    if (!response.ok) {
      var responseMessage = result && result.errorCode === "file_too_large"
        ? "Cette photo dépasse la limite de 8 Mo. Choisis une photo plus légère."
        : result && result.errorCode === "too_many_files"
          ? "Trop de photos ont été envoyées en même temps. Réessaie cette photo."
          : buildErrorMessage(response.status, result);
      var responseError = new Error(responseMessage);
      responseError.retryable = isRetryableUploadStatus(response.status);
      responseError.errorCode = result && result.errorCode || "upload_http_error";
      responseError.uploadId = uploadId;
      throw responseError;
    }

    if (!getUploadedImageUrl(result)) {
      var invalidResponseError = new Error("Le serveur n'a pas retourne l'URL de la photo.");
      invalidResponseError.retryable = false;
      invalidResponseError.errorCode = "upload_invalid_response";
      invalidResponseError.uploadId = uploadId;
      throw invalidResponseError;
    }

    return result;
  }

  function createUploadTraceId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
    return String(Date.now()) + "-" + Math.random().toString(36).slice(2, 12);
  }

  function isRetryableUploadStatus(status) {
    return status === 408 || status === 425 || status === 429 || status >= 500;
  }

  function getUploadedImageUrl(result) {
    return result && (result.imageUrl || result.fileUrl || result.url) || "";
  }

  function wait(delayMs) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, delayMs);
    });
  }

  async function retryFailedUpload(taskKey) {
    var failure = state.uploadFailures.find(function (entry) {
      return entry.task.key === taskKey;
    });

    if (!failure || state.submitting) {
      return;
    }

    state.submitting = true;
    state.submitPhase = "uploading";
        setStatus("Nouvelle tentative pour " + failure.task.file.name + "…", "");
    renderApp();

    try {
      state.uploadCache[taskKey] = await uploadSingleFileWithRetry(failure.task);
      state.uploadFailures = state.uploadFailures.filter(function (entry) {
        return entry.task.key !== taskKey;
      });
      state.uploadedImageCount = getUploadedImageCount();
      setStatus(
        state.uploadFailures.length
          ? "Photo téléversée. Il reste " + state.uploadFailures.length + " photo(s) à réessayer."
          : "Toutes les photos sont téléversées. Tu peux maintenant valider et envoyer.",
        state.uploadFailures.length ? "" : "success"
      );
    } catch (error) {
      failure.message = error.message;
      setStatus("Cette photo n’a toujours pas pu être téléversée. " + error.message, "error");
    } finally {
      state.submitting = false;
      state.submitPhase = "";
      requestScrollToBottom();
      renderApp();
    }
  }

  function buildUploadStatusMessage(completedCount, totalCount) {
    if (!totalCount) {
      return "Preparation de la demande...";
    }

    if (!completedCount) {
      return "Transmission des photos en cours...";
    }

    return "Transmission des photos (" + completedCount + "/" + totalCount + ")...";
  }

  async function parseResponse(response) {
    var text = await response.text();

    if (!text) {
      return {};
    }

    try {
      return JSON.parse(text);
    } catch (_error) {
      return { message: text };
    }
  }

  function buildErrorMessage(status, result) {
    if (result && result.errorCode === "invalid_payload") {
      return "Certaines informations ne sont pas valides. Vérifie les champs indiqués, puis réessaie.";
    }

    if (result && result.errorCode === "turnstile_failed") {
      return "La vérification de sécurité n’a pas abouti. Réessaie, s’il te plaît.";
    }

    if (result && result.errorCode === "turnstile_required") {
      return "Une vérification de sécurité est nécessaire avant l’envoi.";
    }

    if (result && result.error) {
      return result.error + " (" + status + ")";
    }

    return "Une erreur est survenue pendant l’envoi (" + status + "). Réessaie, s’il te plaît.";
  }

  function resetFlow() {
    clearIntroTimers();
    revokeAllImagePreviews();
    state.requestNumber = null;
    state.currentStepIndex = 0;
    state.shoeCount = 1;
    state.phoneTooLong = false;
    state.submitting = false;
    state.completed = false;
    state.returnToSummary = false;
    clearStepPromptDelay();
    clearOperatorActionDelay();
    state.promptDelayActive = false;
    state.actionDelayActive = false;
    state.introVisibleCount = 0;
    state.introSequenceStarted = false;
    state.operatorTypingCompleted = {};
    state.submitPhase = "";
    state.activeImageSlot = null;
    state.galleryStepId = null;
    state.uploadedImageCount = 0;
    state.uploadCache = {};
    state.uploadFailures = [];
    state.status = { message: "", tone: "" };
    state.answers = buildInitialAnswers();
    renderApp();
    if (state.isOpen) {
      startIntroSequence();
    }
  }

  function revokeAllImagePreviews() {
    for (var shoeIndex = 1; shoeIndex <= config.maxShoes; shoeIndex += 1) {
      (state.answers["images_" + String(shoeIndex)] || []).forEach(revokeImagePreview);
    }
  }

  function startIntroSequence() {
    if (state.currentStepIndex !== 0 || state.completed) {
      clearStepPromptDelay();
      state.promptDelayActive = false;
      state.introVisibleCount = 2;
      state.introSequenceStarted = true;
      return;
    }

    if (state.introSequenceStarted && state.introVisibleCount >= 2) {
      return;
    }

    clearIntroTimers();
    state.introSequenceStarted = true;

    [1, 2].forEach(function (count, index) {
      var timer = setTimeout(function revealIntroMessage() {
        if (count === 2 && !state.operatorTypingCompleted.intro) {
          var retryTimer = setTimeout(revealIntroMessage, 100);
          introTimers.push(retryTimer);
          return;
        }

        if (count === 2) {
          var readingDelayTimer = setTimeout(function () {
            state.introVisibleCount = count;
            requestScrollToBottom();
            renderApp();
          }, 550);
          introTimers.push(readingDelayTimer);
          return;
        }

        state.introVisibleCount = count;
        requestScrollToBottom();
        renderApp();
      }, 900 + (index * 2300));

      introTimers.push(timer);
    });
  }

  function clearIntroTimers() {
    introTimers.forEach(function (timer) {
      clearTimeout(timer);
    });
    introTimers = [];
  }

  function startStepPromptDelay() {
    clearStepPromptDelay();
    clearOperatorActionDelay();
    var step = getCurrentStep();

    if (!step || step.id === "shoeCount" || step.id === "summary" || state.completed) {
      state.promptDelayActive = false;
      state.actionDelayActive = false;
      return;
    }

    if (state.operatorTypingCompleted[getStepPromptKey(step)]) {
      state.promptDelayActive = false;
      state.actionDelayActive = false;
      return;
    }

    state.promptDelayActive = true;
    promptDelayTimer = setTimeout(function () {
      promptDelayTimer = null;
      state.promptDelayActive = false;
      state.actionDelayActive = true;
      renderApp();
    }, 1400);
  }

  function clearStepPromptDelay() {
    if (promptDelayTimer !== null) {
      clearTimeout(promptDelayTimer);
      promptDelayTimer = null;
    }
    state.promptDelayActive = false;
  }

  function clearOperatorActionDelay() {
    if (operatorActionDelayTimer !== null) {
      clearTimeout(operatorActionDelayTimer);
      operatorActionDelayTimer = null;
    }
    state.actionDelayActive = false;
  }

  function startOperatorTypingEffects() {
    root.querySelectorAll("[data-operator-text]").forEach(function (copy) {
      var messageKey = copy.getAttribute("data-operator-key") || copy.getAttribute("data-operator-text") || "";
      if (state.operatorTypingCompleted[messageKey]) {
        copy.textContent = copy.getAttribute("data-operator-text") || "";
        return;
      }
      var text = copy.getAttribute("data-operator-text") || "";
      var duration = Math.max(900, Math.min(2200, text.length * 28));
      var startedAt = Date.now();
      copy.textContent = "";
      copy.classList.add("cobbler-chatbot__message-copy--typing");

      var timer = window.setInterval(function () {
        var progress = Math.min(1, (Date.now() - startedAt) / duration);
        copy.textContent = text.slice(0, Math.ceil(text.length * progress));
        if (progress >= 1) {
          window.clearInterval(timer);
          copy.classList.remove("cobbler-chatbot__message-copy--typing");
          state.operatorTypingCompleted[messageKey] = true;
          var currentStep = getCurrentStep();
          if (state.actionDelayActive && currentStep && messageKey === getStepPromptKey(currentStep)) {
            operatorActionDelayTimer = window.setTimeout(function () {
              operatorActionDelayTimer = null;
              state.actionDelayActive = false;
              renderApp();
            }, 550);
          }
        }
      }, 35);

      operatorTypingTimers.push(timer);
    });
  }

  function clearOperatorTypingTimers() {
    operatorTypingTimers.forEach(function (timer) {
      window.clearInterval(timer);
    });
    operatorTypingTimers = [];
  }

  function getStepPromptKey(step) {
    return step && step.id ? "prompt:" + step.id : "";
  }

  function getStepPromptText(step) {
    if (step && step.type === "images" && step.shoeIndex === 1 && state.shoeCount === 1) {
      return "Concernant cette paire.";
    }

    return step && step.prompt ? step.prompt : "";
  }

  function setStatus(message, tone) {
    state.status.message = message;
    state.status.tone = tone || "";
  }

  function clearStatus() {
    setStatus("", "");
  }

  function requestScrollToBottom() {
    scrollIntent = "bottom";
  }

  function restoreScroll(previousScrollTop, shouldFollowBottom) {
    var panelBody = root.querySelector(".cobbler-chatbot__panel-body");

    if (!panelBody) {
      scrollIntent = "";
      return;
    }

    if (scrollIntent === "bottom" || shouldFollowBottom) {
      panelBody.scrollTop = panelBody.scrollHeight;
      scrollIntent = "";
      return;
    }

    panelBody.scrollTop = previousScrollTop;
    scrollIntent = "";
  }

  function isNearBottom(element) {
    return element.scrollHeight - (element.scrollTop + element.clientHeight) < 48;
  }

  function toggleMultiSelectAnswer(stepId, value) {
    var values = state.answers[stepId] || [];
    var index = values.indexOf(value);

    if (index === -1) {
      values.push(value);
    } else {
      values.splice(index, 1);
    }

    state.answers[stepId] = values;
  }

  function removeSelectedImage(imageStepId, index) {
    var files = state.answers[imageStepId] || [];
    if (index < 0 || index >= files.length) {
      return;
    }
    revokeImagePreview(files[index]);
    files.splice(index, 1);
    state.answers[imageStepId] = files;
    pruneUploadState();
  }

  function mergeSelectedImages(existingFiles, incomingFiles, maxCount, maxBytes, targetSlot) {
    var result = existingFiles.slice();
    var signatures = {};
    var skippedLimit = 0;
    var skippedSize = 0;
    var skippedFileSize = 0;
    var skippedTypeNames = [];
    var selectedBytes = getFilesSize(result);
    var selectedCount = countSelectedFiles(result);
    var nextSlot = Number.isInteger(targetSlot) ? targetSlot : findFirstEmptyImageSlot(result);

    result.forEach(function (file) {
      signatures[buildFileSignature(file)] = true;
    });

    incomingFiles.forEach(function (file) {
      var signature = buildFileSignature(file);
      if (signatures[signature]) {
        return;
      }
      if (selectedCount >= maxCount) {
        skippedLimit += 1;
        return;
      }
      if (!isSupportedImageFile(file)) {
        skippedTypeNames.push(file.name || "fichier sélectionné");
        return;
      }
      if (file.size > config.maxUploadFileBytes) {
        skippedFileSize += 1;
        return;
      }
      if (selectedBytes + file.size > maxBytes) {
        skippedSize += 1;
        return;
      }
      file = prepareImageFile(file);
      signatures[signature] = true;
      while (nextSlot < config.maxImagesPerShoe && result[nextSlot]) {
        nextSlot += 1;
      }
      if (nextSlot >= config.maxImagesPerShoe) {
        skippedLimit += 1;
        return;
      }
      result[nextSlot] = file;
      nextSlot += 1;
      selectedCount += 1;
      selectedBytes += file.size;
    });

    return {
      files: result,
      skippedLimit: skippedLimit,
      skippedSize: skippedSize,
      skippedFileSize: skippedFileSize,
      skippedTypeNames: skippedTypeNames
    };
  }

  function isSupportedImageFile(file) {
    var allowedTypes = {
      "image/jpeg": true,
      "image/png": true,
      "image/webp": true,
      "image/heic": true,
      "image/heif": true
    };
    var type = String(file && file.type || "").toLowerCase();
    if (type) {
      return Boolean(allowedTypes[type]);
    }
    var name = String(file && file.name || "").toLowerCase();
    return /\.(jpe?g|png|webp|heic|heif)$/.test(name);
  }

  function buildFileSignature(file) {
    return [file.name, file.size, file.lastModified].join("|");
  }

  function countSelectedFiles(files) {
    return (files || []).filter(function (file) {
      return Boolean(file);
    }).length;
  }

  function findFirstEmptyImageSlot(files) {
    var source = files || [];
    for (var index = 0; index < config.maxImagesPerShoe; index += 1) {
      if (!source[index]) {
        return index;
      }
    }
    return null;
  }

  function prepareImageFile(file) {
    if (!file.previewUrl && window.URL && window.URL.createObjectURL) {
      file.previewUrl = window.URL.createObjectURL(file);
    }
    return file;
  }

  function revokeImagePreview(file) {
    if (file && file.previewUrl && window.URL && window.URL.revokeObjectURL) {
      window.URL.revokeObjectURL(file.previewUrl);
      delete file.previewUrl;
    }
  }

  function buildUploadTaskKey(shoeIndex, file) {
    return String(shoeIndex) + "|" + buildFileSignature(file);
  }

  function getFilesSize(files) {
    return (files || []).reduce(function (total, file) {
      return total + (Number(file.size) || 0);
    }, 0);
  }

  function getFirstSelectedFile(files) {
    return (files || []).find(function (file) {
      return Boolean(file && file.name);
    });
  }

  function getTotalSelectedImageBytes() {
    var total = 0;
    for (var shoeIndex = 1; shoeIndex <= state.shoeCount; shoeIndex += 1) {
      total += getFilesSize(state.answers["images_" + String(shoeIndex)] || []);
    }
    return total;
  }

  function getUploadedImageCount() {
    return buildUploadTasks().filter(function (task) {
      return Boolean(state.uploadCache[task.key]);
    }).length;
  }

  function pruneUploadState() {
    var activeKeys = {};
    buildUploadTasks().forEach(function (task) {
      activeKeys[task.key] = true;
    });

    Object.keys(state.uploadCache).forEach(function (key) {
      if (!activeKeys[key]) {
        delete state.uploadCache[key];
      }
    });
    state.uploadFailures = state.uploadFailures.filter(function (failure) {
      return Boolean(activeKeys[failure.task.key]);
    });
  }

  function buildIssueSummaryText(issueStepId) {
    var values = state.answers[issueStepId] || [];
    if (!values.length) {
      return "-";
    }

    var detail = state.answers[getIssueDetailKey(issueStepId)] || "";
    return values.map(function (value) {
      if (value === "Autre probleme") {
        return detail || issueChoiceLabels[value];
      }

      return issueChoiceLabels[value] || value;
    }).join(", ");
  }

  function buildIssuePayloadText(issueStepId) {
    var values = state.answers[issueStepId] || [];
    var detail = state.answers[getIssueDetailKey(issueStepId)] || "";
    return values.map(function (value) {
      return value === "Autre probleme" ? (detail || value) : value;
    }).join(", ");
  }

  function buildShoeTypeSummaryText(shoeTypeStepId) {
    var values = state.answers[shoeTypeStepId] || [];
    if (!values.length) {
      return "-";
    }

    var detail = state.answers[getShoeTypeDetailKey(shoeTypeStepId)] || "";
    return values.map(function (value) {
      if (value === "Autre") {
        return detail || shoeTypeLabels[value];
      }

      return shoeTypeLabels[value] || value;
    }).join(", ");
  }

  function buildShoeTypePayloadText(shoeTypeStepId) {
    var values = state.answers[shoeTypeStepId] || [];
    var detail = state.answers[getShoeTypeDetailKey(shoeTypeStepId)] || "";
    return values.map(function (value) {
      return value === "Autre" ? (detail || value) : value;
    }).join(", ");
  }

  function getTotalSelectedImages() {
    var total = 0;

    for (var shoeIndex = 1; shoeIndex <= state.shoeCount; shoeIndex += 1) {
      total += countSelectedFiles(state.answers["images_" + String(shoeIndex)] || []);
    }

    return total;
  }

  function isMultiSelectStep(stepId) {
    return isIssueStep(stepId) || isShoeTypeStep(stepId);
  }

  function isIssueStep(stepId) {
    return /^issue_[0-9]+$/.test(String(stepId || ""));
  }

  function isShoeTypeStep(stepId) {
    return /^shoeType_[0-9]+$/.test(String(stepId || ""));
  }

  function isContactStep(stepIndex) {
    var step = steps[stepIndex];
    return Boolean(step && (step.id === "customerName" || step.id === "customerPhone"));
  }

  function isImageStep(stepId) {
    return /^images_[0-9]+$/.test(String(stepId || ""));
  }

  function isAddShoeStep(stepId) {
    return /^addShoe_[0-9]+$/.test(String(stepId || ""));
  }

  function parseAddShoeTarget(stepId) {
    var match = String(stepId || "").match(/^addShoe_([0-9]+)$/);
    return match ? Number(match[1]) : 2;
  }

  function getIssueDetailKey(issueStepId) {
    return "issueDetail_" + String(issueStepId).split("_")[1];
  }

  function getShoeTypeDetailKey(shoeTypeStepId) {
    return "shoeTypeDetail_" + String(shoeTypeStepId).split("_")[1];
  }

  function formatCanadaPhoneInput(value) {
    var rawValue = String(value || "");
    var inputDigits = rawValue.replace(/\D/g, "");

    if (!inputDigits.length) {
      return "";
    }

    // Keep extra digits visible so the user can correct them; never truncate silently.
    if (inputDigits.length > 11) {
      return rawValue.trim();
    }

    var digits = inputDigits;
    if (digits.length && digits.charAt(0) !== "1") {
      digits = "1" + digits;
    }

    if (digits.length > 11) {
      return rawValue.trim();
    }

    var national = digits.slice(1);
    var partA = national.slice(0, 3);
    var partB = national.slice(3, 6);
    var partC = national.slice(6, 10);
    var formatted = "+1";

    if (partA.length) {
      formatted += " (" + partA;
      if (partA.length === 3) {
        formatted += ")";
      }
    }

    if (partB.length) {
      formatted += " " + partB;
    }

    if (partC.length) {
      formatted += "-" + partC;
    }

    return formatted.trim();
  }

  function isValidCanadaPhone(value) {
    var digits = String(value || "").replace(/\D/g, "");
    if (digits.length !== 11 || digits.charAt(0) !== "1") {
      return false;
    }

    var national = digits.slice(1);
    var areaCode = national.slice(0, 3);
    var exchange = national.slice(3, 6);
    if (!/^[2-9][0-9]{2}$/.test(areaCode) || !/^[2-9][0-9]{2}$/.test(exchange)) {
      return false;
    }

    if (/^(\d)\1{9}$/.test(national) || /^(?:0{3}|1{3}|9{3})/.test(areaCode + exchange)) {
      return false;
    }

    return true;
  }

  function normalizeCanadaPhoneForPayload(value) {
    var digits = String(value || "").replace(/\D/g, "");
    if (digits.length === 10) {
      digits = "1" + digits;
    }
    if (digits.length !== 11 || digits.charAt(0) !== "1") {
      return String(value || "").trim();
    }

    return "+1 " + digits.slice(1, 4) + " " + digits.slice(4, 7) + " " + digits.slice(7, 11);
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function escapeAttribute(value) {
    return escapeHtml(value).replace(/\n/g, " ");
  }
})();
